import { useSelector } from "react-redux";
import { selectCurrent } from "../../../redux/settings/selectors";
import { selectWebsiteCardsListItems } from "../../../redux/websiteCards/selector";
import { useEffect, useState } from "react";
import storePersist from "../../../redux/storePersist";
import { useAppDispatch } from "../../../hooks/hooks";
import { websiteCards } from "../../../redux/websiteCards/action";
import _ from 'lodash'
import { getCardData } from "../../../common/services/website-card.service";
import { guestToken } from "../../../redux/auth/actions";
import { queryByStore } from "../../../redux/query-by-store/action";
import { organizationUnits } from "../../../redux/organizationUnits/action";
import { library } from "../../../redux/library/action";
import { countries } from "../../../redux/countries/action";
import { states } from "../../../redux/states/action";
import { websites } from "../../../redux/websites/action";
import { settings } from "../../../redux/settings/actions";
import GetQuote from "../../../models/GetQuote";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import GoogleMapSearch from "../../../common/components/google-map-search";
import { leads } from "../../../redux/leads/action";
import { cmsSettings } from "../../../redux/cmsSettings/action";
import useWindowDimensions from "../../../hooks/useWindowsDimensions";
import { useNavigate } from "react-router-dom";
import { selectOrganizationUnitsListItems } from "../../../redux/organizationUnits/selector";
import PageLoader from "../../../components/PageLoader";
import moment from "moment";
import { getHostName, getOrigin } from "../../../common/services/common.service";
const slider1 = require('./../../../assets/img/slider1.png')
const slider2 = require('./../../../assets/img/slider2.png')

const LogisticHome = () => {
	const dispatch = useAppDispatch()
	let navigate = useNavigate()
	const [isLoading, setIsLoading] = useState<boolean>(true)
	const { height, width } = useWindowDimensions();
	//const { result } = useSelector(selectCurrent)
	const [color, setColor] = useState('universal')
	const defaultSetting = useSelector(selectCurrent)
	const { theme, primary, secondary } = defaultSetting
	const [logo, setLogo] = useState<any>()
	const organizationLists = useSelector(selectOrganizationUnitsListItems)
	const websiteCardsList = useSelector(selectWebsiteCardsListItems)
	const [index, setIndex] = useState(0);
	const [generateIds, setGenerateIds] = useState<any>([]);
	const [leadValues, setLeadValues] = useState<any>()
	const [tenantId, setTenantId] = useState<Number>();

	const [isMandatoryApiCallsCompleted, setIsMandatoryApiCallsCompleted] = useState<boolean>(false);
	const [searchedLocation, setSearchedLocation] = useState({
		name: '',
		lat: '',
		long: '',
		pincode: '',
		description: '',
	});


	const [searchedToLocation, setSearchedToLocation] = useState({
		name: '',
		lat: '',
		long: '',
		pincode: '',
		description: '',
	});

	const handleChange: any = (event: any, field: string) => {
		setLeadValues({ ...leadValues, [field]: event })
	}

	// Guest API
	const getGuestToken = async () => {
		await dispatch(guestToken({
			loginData: [
				{
					"Context": {
						"domain": "string",
						"core_version": "string",
						"bap_id": getHostName(),
						"bap_uri": getOrigin(),
						"bpp_id": "string",
						"bpp_uri": "string",
						"city": "string",
						"country": "string",
						"action": "string",
						"transaction_id": "string",
						"message_id": "string",
						"timestamp": moment.utc(),
						"ttl": "string",
						"Subscription": "Logisitcs",
						"Domain": "Logisitcs",
						"SubDomains": [
							"Delivery"
						],
						"Network": "Logistics_Customer",
						"Application": "Customer",
						"Channel": "CSP"
					},
					"Message": {
						"AccountType": "Logistics_Customer"
					}
				}
			]
		}));
	}
	// Mandatory API
	const mandatoryAPICalls = async () => {
		setIsMandatoryApiCallsCompleted(false);
		if (storePersist.get('guestTokenMetadata').current?.success) {
			await dispatch(websites.list({
				url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

					"Filters": [
						{
							"FieldName": "PlatformWebSiteId",
							"FilterOperatorId": 1,
							"FieldValue": 30,
							"FieldType": "number"
						}
					],

				}
			}))

			await dispatch(websiteCards.list({
				url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`, entity: 'websiteCards', jsonData: {

					"Filters": [
						{
							"FieldName": "WebsiteName",
							"FilterOperatorId": 1,
							"FieldValue": storePersist?.get("websites")?.current[0]?.WebSiteName,
							"FieldType": "text"
						}
					]

				}
			}))
			await setIsLoading(false)
		}
		setIsMandatoryApiCallsCompleted(true);
	}
	// Deferred API
	const deferredAPICalls = async () => {
		if (storePersist.get('guestTokenMetadata').current?.success) {
			await dispatch(organizationUnits.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`, entity: 'organizationUnits', jsonData: {} }))
			await dispatch(queryByStore.list({ url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/localization/query-by-store`, entity: 'queryByStores', jsonData: {} }))
			await dispatch(library.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/query-by-list`, entity: 'library' }))
			await dispatch(countries.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/countrys`, entity: 'countries' }))
			await dispatch(states.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/stateprovinces`, entity: 'states' }))
			await dispatch(cmsSettings.list({ url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/cms/query`, entity: 'cmsSettings', jsonData: {} }))
		}
		fetchLogo()
	}

		// app initialization
		useEffect(() => {		
			(async()=>{
				await getGuestToken();
				const tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
				setTenantId(tenantId)
				generateIdValue()
			})();		
		}, []);

	const generateUniqueId = () => {
		const randomPart = Math.random().toString(36).substr(2, 9); // Random part
		const timestampPart = Date.now().toString(36); // Timestamp part
		return `${randomPart}-${timestampPart}`;
	};

	const generateIdValue = () => {
		const newItem = {
			transaction_id: generateUniqueId(),
			message_id: generateUniqueId(),
		};
		setGenerateIds(newItem);
	};

	const fetchLogo = () => {

		const storeData = {
			logoDark: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
				return logo.Background === 'Light'
			}),
			logoLight: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
				return logo.Background === 'Dark'
			}),
			storeName: organizationLists?.result?.items[0]?.BrandMappings[0]?.Name,
			description: organizationLists?.result?.items[0]?.BrandMappings[0]?.Description,
			favicon: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Favicons[0]?.Url || '/assets/images/logo.png'
		}
		setLogo(storeData)
	}
	
	useEffect(() => {
		(async () => {
			if (tenantId) {
				switch (tenantId) {
					// case 108: //Tranze qa
					// case 144: //Tranze prod
					// 	console.log('reading agri card data from table')
					// 	await readCardsFromTableStorage(process.env.REACT_APP_AZURE_STORAGE_SAS_CONNECTION_STRING_AGRI,'RetailUCP' )
					// 	break;
					// case 97:  //DBS qa
					// case 130: //DBS prod
					// 	await readCardsFromTableStorage(process.env.REACT_APP_AZURE_STORAGE_SAS_CONNECTION_STRING_DBS)
					// 	break;
					// case 154: // CAUVERYCOLLEGE prod
					// 	await readCardsFromTableStorage(process.env.REACT_APP_AZURE_STORAGE_SAS_CONNECTION_STRING_CAUVERYCOLLEGE)
					// 	break;
					default:
						await mandatoryAPICalls();
				}

				deferredAPICalls();

			}
		})()
	}, [tenantId])


	const highLightContentHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_GALLERY2_HEADING') : null;

	const highLightContentData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_GALLERY2') : null;

	const workContentHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_SECTION1_HEADING') : null;

	const workContentData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_SECTION1') : null;

	const promiseContentHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_SECTION2_HEADING') : null;

	const promiseContentData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_SECTION2') : null;

	const partnerConentData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_PARTNER') : null;

	const sliderData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_SLIDER') : null;

	const aboutUsHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_ABOUTUS') : null;

	const domesticCourierHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_DOMESTIC_COURIER_HEADING') : null;

	const domesticCourierContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_DOMESTIC_COURIER') : null;

	const internationalCourierHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_INTERNATIONAL_COURIER_HEADING') : null;

	const internationalCourierContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_INTERNATIONAL_COURIER') : null;

	const copyRightsContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_COPYRIGHTS') : null;

	const handleNavigate = (path: any) => {
		navigate(`${path}`)
	}
	const handleSubmit = (event: any) => {
		event?.preventDefault()
		const fromAddressData = _.split(searchedLocation?.description, ',');
		const toAddressData = _.split(searchedToLocation?.description, ',');

		dispatch(leads.create({
			url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads`, entity: 'leadCreate', jsonData: {
				"Records": [
					{
						Context: {
							transaction_id: generateIds?.transaction_id,
							message_id: generateIds?.message_id,
						},
						Message: {
							LeadInfo: {
								Name: leadValues?.Name,
								Email: leadValues?.Email,
								PhoneNumber: leadValues?.PhoneNumber,
								date: leadValues?.date,
								Description: '',
								IsExistingUser: leadValues?.IsExistingUser || false,
								LeadPayload: {
									weight: {
										unit: '',
										value: 0
									},
									dimensions: {
										length: {
											unit: '',
											value: 0
										},
										breadth: {
											unit: '',
											value: 0
										},
										height: {
											unit: '',
											value: 0
										}
									},
									category: '',
									value: {
										currency: 'INR',
										value: 0
									},
									dangerous_goods: false
								},
								start: {
									location: {
										gps: `${searchedLocation?.lat},${searchedLocation?.long}`,
										address: {
											name: searchedLocation?.name,
											building: searchedLocation?.description,
											locality: `${fromAddressData[0]},${fromAddressData[1]}`,
											city: searchedLocation?.name,
											state: fromAddressData[3],
											country: 'India',
											area_code: searchedLocation?.pincode,
										},
									},
								},

								end: {
									location: {
										gps: `${searchedToLocation?.lat},${searchedToLocation?.long}`,
										address: {
											name: searchedToLocation?.name,
											building: searchedToLocation?.description,
											locality: `${toAddressData[0]},${toAddressData[1]}`,
											city: searchedToLocation?.name,
											state: toAddressData[3],
											country: 'India',
											area_code: searchedToLocation?.pincode,
										},
									},
								},
							}
						}
					}
				]
			}
		})).then(() => {
			setSearchedLocation({
				name: '',
				lat: '',
				long: '',
				pincode: '',
				description: '',
			});
			setSearchedToLocation({
				name: '',
				lat: '',
				long: '',
				pincode: '',
				description: '',
			});
			setLeadValues({
				Name: '',
				Email: '',
				PhoneNumber: '',
				date: '',
				IsExistingUser: '',
			})
			dispatch(settings.set({
				quoteData: leadValues,
				searchedLocation,
				searchedToLocation,
			}))
			dispatch(settings.set({ getQuote: 'open' }))
		})


	}
	useEffect(() => {
		setColor(theme)



	}, [theme, width]);
	return (
		<>
			{!isMandatoryApiCallsCompleted ? <PageLoader /> :
				<div>
					{width && width < 720 ? <div className={`max-h-screen  primary-${color}`}>
						<div className="h-full overflow-y-auto">
							<div className="flex flex-col justify-around items-center w-screen h-max mt-10 p-5">
								<div className="flex flex-col justify-between items-center w-full  p-5">
									<Carousel
										autoPlay
										infiniteLoop
										showStatus={false}
										showIndicators={false}
										showThumbs={false}>
										{sliderData?.map((banner: any) => (
											<div>
												<img src={banner?.src} className=" h-32" />
											</div>
										))}
									</Carousel>
									<div className={`w-full  flex justify-center items-start`}>
										<div className={`absolute w-full text-xl mt-60 italic inset-0 z-10 h-max flex items-start justify-start text-center px-5`}>
											<div className={`rounded-3xl p-3 px-4 shadow  border-x border-y `}>Meet the World Largest Leading Global Logistic</div>
										</div>
										<img src={require('./../../../assets/img/worldmap.png')} className="w-[300px] h-48 brightness-75	   " />
									</div>
								</div>
								<div className={`w-full m-5 justify-center item-center rounded-xl secondary-${color}`}>
									<div className=" w-full p-1 flex flex-col justify-center items-center rounded-xl">
										<div className=" uppercase font-bold">Instant Quote Calculator</div>
										<div className=" w-full px-3 font-bold space-y-2">
											<div className="flex flex-row ">
												<div className=" w-full text-xs flex flex-row justify-start items-center">
													<input
														type="checkbox"
														name={"from"}
														placeholder=""
														className={`px-2 teritary-${color} text-xs px-3`}
														onChange={(event) => {
															handleChange(
																event.target.checked,
																'IsExistingUser'
															)
														}}
														value={leadValues?.IsExistingUser}
													/>
													<div className="mx-2">Are You Already Register?</div>
												</div>
											</div>
											{!leadValues?.IsExistingUser ? <>
												<div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Name
														</label>
														<div className="border-0  text-xs ">
															<input
																type="text"
																name={"Name"}
																placeholder="Enter the Full Name"
																className={`w-full py-1 teritary-${color} bg-opacity-0 text-xs px-3`}
																onChange={(event) => {
																	handleChange(
																		event.target.value,
																		'Name'
																	);
																}}
																value={leadValues?.Name} />
														</div>
													</div>
												</div>
												<div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Email
														</label>
														<div className="border-0   text-xs ">
															<input
																type="email"
																name={"Email"}
																placeholder="Enter the Email"
																className={`w-full py-1 teritary-${color} bg-opacity-0 text-xs px-3`}
																onChange={(event) => {
																	handleChange(
																		event.target.value,
																		'Email'
																	);
																}}
																value={leadValues?.Email} />
														</div>
													</div>
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Mobile
														</label>
														<div className="border-0  text-xs ">
															<input
																type="number"
																name={"PhoneNumber"}
																placeholder="Enter the Phone Number"
																className={`w-full py-1  teritary-${color} bg-opacity-0 text-xs px-3`}
																onChange={(event) => {
																	handleChange(
																		event.target.value,
																		'PhoneNumber'
																	);
																}}
																value={leadValues?.PhoneNumber} />
														</div>
													</div>
												</div>
												<div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															From
														</label>
														<div className="border-0   text-xs ">
															<GoogleMapSearch
																setLocation={setSearchedLocation}
																location={searchedLocation}
																placeholder="From Address" />

														</div>
													</div>
												</div>
												<div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															To
														</label>
														<div className="border-0   text-xs ">
															<GoogleMapSearch
																setLocation={setSearchedToLocation}
																location={searchedToLocation}
																placeholder="To Address" />
														</div>
													</div>
												</div>
												<div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Schedule Date
														</label>
														<div className="border-0   text-xs ">
															<input
																type="date"
																name={"frodatem"}
																min={new Date().toISOString().split("T")[0]}
																placeholder=""
																className={`w-full py-1 teritary-${color} bg-opacity-0 text-xs px-3`}
																onChange={(event) => {
																	handleChange(
																		event.target.value,
																		'date'
																	);
																}}
																value={leadValues?.date} />
														</div>
													</div>
												</div></> :
												<>
													<div className="flex flex-row space-x-2">
														<div className=" w-full">
															<label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																Login with Email or PhoneNumber
															</label>
															<div className="border-0  text-xs ">
																<input
																	type="text"
																	name={"Email"}
																	placeholder="Login with Email or PhoneNumber"
																	className={`w-full py-1 teritary-${color} bg-opacity-0 text-xs px-3`}
																	onChange={(event) => {
																		handleChange(
																			event.target.value,
																			'Email'
																		);
																	}}
																	value={leadValues?.Email} />
															</div>
														</div>

													</div><div className="flex flex-row space-x-2">
														<div className=" w-full">
															<label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																From
															</label>
															<div className="border-0   text-xs ">
																<GoogleMapSearch
																	setSearchedLocation={setSearchedLocation}
																	searchedLocation={searchedLocation}
																	placeholder="From Address" />

															</div>
														</div>
													</div><div className="flex flex-row space-x-2">
														<div className=" w-full">
															<label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																To
															</label>
															<div className="border-0  bg-[#F3F4F6FF] text-xs ">
																<GoogleMapSearch
																	setSearchedLocation={setSearchedToLocation}
																	searchedLocation={searchedToLocation}
																	placeholder="To Address" />
															</div>
														</div>
													</div><div className="flex flex-row space-x-2">
														<div className=" w-full">
															<label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																Schedule Date
															</label>
															<div className="border-0  bg-[#F3F4F6FF] text-xs ">
																<input
																	type="date"
																	name={"frodatem"}
																	min={new Date().toISOString().split("T")[0]}
																	placeholder=""
																	className="w-full py-1 bg-black bg-opacity-0 text-xs px-3"
																	onChange={(event) => {
																		handleChange(
																			event.target.value,
																			'date'
																		);
																	}}
																	value={leadValues?.date} />
															</div>
														</div>
													</div></>
											}

										</div>


										<div className={`primary-${color} px-5 rounded-3xl flex flex-row space-x-1 flex item-center justify-center mt-5 mb-2 `}>
											<div
												onClick={handleSubmit}
												className=" uppercase text-xs my-3 font-bold">
												Get Quote
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="w-full flex  items-center justify-around flex-col h-max  border-y border-black border-opacity-20">
								<div className={`secondary-${color} w-full py-5 flex flex-col justify-around items-center`}>
									<div className="">
										<svg version="1.1" id="layer" fill={primary} xmlns="http://www.w3.org/2000/svg"
											width="100" height="100" viewBox="0 0 612 612.001"
										>
											<path d="M305.058,329.286V570.82l192.293-36.491V416.644c0-4.926,4.291-8.752,9.185-8.19l23.658,3.661
c4.162,0.478,7.305,4.001,7.305,8.19v136.717c0,3.885-2.713,7.243-6.512,8.061l-210.5,45.261
c-10.172,2.188-20.691,2.211-30.873,0.069L81.373,566.609c-3.738-0.786-6.446-4.037-6.545-7.854L71.23,419.907
c-0.112-4.354,3.181-8.046,7.521-8.427l176.886-15.543c3.068-0.269,5.73-2.226,6.902-5.074l26.648-64.716
C292.628,317.796,305.058,320.254,305.058,329.286z M69.23,250.204L13.721,368.855c-2.713,5.798,1.928,12.34,8.297,11.697
l208.464-21.064c2.946-0.298,5.505-2.152,6.707-4.858l67.075-151.111l-229.056,42.07C72.587,246.071,70.36,247.79,69.23,250.204z
M304.264,203.518l70.976,155.837c1.24,2.723,3.859,4.561,6.842,4.801l208.069,16.732c6.271,0.505,10.773-5.916,8.163-11.64
L544.05,250.284c-1.122-2.46-3.38-4.213-6.041-4.692L304.264,203.518z M245.942,80.473l51.515,89.207
c3.967,6.869,13.882,6.868,17.848,0l51.504-89.207c3.967-6.87-0.991-15.457-8.923-15.457h-25.748v-54.71
C332.138,4.614,327.525,0,321.833,0h-30.914c-5.691,0-10.305,4.614-10.305,10.305v54.71h-25.749
C246.933,65.015,241.975,73.603,245.942,80.473z"/>
										</svg>
									</div>
									<div className="flex flex-col justify-center items-center">
										<div className={`p-2 flex flex-col justify-center items-center space-y-1 py-2 `}>
											<div className="uppercase font-bold">Track Your Order</div>
											<div className=" text-[10px]">Enter tracking number and get traking result</div>
										</div>
										<div className={`flex flex-row bg-opacity-10  teritary-${color}  rounded-3xl item-center justify-center my-3`}>
											<input
												type="type"
												name={"from"}
												placeholder=""
												className="w-max bg-transparent p-1  text-xs px-5"
												onChange={(e) => console.log('')}
												value={""}
											/>
											<div className={`w-max secondary-${color}  px-5 rounded-3xl flex flex-row  item-center justify-center`}>
												<a className="hover:text-[#FFB934] uppercase text-xs my-3 font-bold" href="#">Track Order</a>
											</div>
										</div>
									</div>
									<div className="">
										<svg className="my-3" version="1.1" fill={primary} id="layer" width="100" height="100" viewBox="0 0 612 612">
											<path d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078
C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541
c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z
 M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812
c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812
h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16
c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z
 M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539
c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751
c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907
c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29
l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697
c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347
C565.257,281.569,563.532,285.839,560.084,285.839z"/>
										</svg>
									</div>
								</div>
							</div>
							<div className={`w-screen flex items-center justify-center flex-col my-10 secondary-${color}`}>
								<div className="uppercase font-bold text-xl">{highLightContentHeading ? highLightContentHeading[0]?.title : null}</div>
								<div className="flex flex-col item-center justify-center">
									<div className={`flex flex-col justify-around py-5 items-center secondary-${color} `}>
										<svg id="layer" fill={primary} height="100" width="100" version="1.1" viewBox="0 0 298.994 298.994">
											<circle cx="49.774" cy="46.77" r="20.242" />
											<path d="M75.908,73.465c-6.511,0-45.899,0-52.434,0c-12.681,0-23.05,10.317-23.113,22.998L0,168.216
	c-0.027,5.394,4.324,9.789,9.718,9.816c0.017,0,0.033,0,0.05,0c5.371,0,9.739-4.341,9.766-9.718l0.361-71.755
	c0.005-1.04,0.851-1.879,1.891-1.877c1.04,0.003,1.881,0.846,1.881,1.886l0.005,164.177c0,6.473,5.247,11.72,11.72,11.72
	s11.72-5.247,11.72-11.72v-93.682h5.06v93.682c0,6.473,5.247,11.72,11.72,11.72s11.72-5.247,11.72-11.72
	c0-85.478-0.207-81.226-0.213-164.275c0-1.129,0.915-2.045,2.044-2.045c1.129,0,2.044,0.915,2.045,2.044
	c0,0.029-0.001,0.058-0.001,0.088l0.361,71.754c0.027,5.377,4.394,9.718,9.766,9.718c0.016,0,0.034,0,0.05,0
	c5.394-0.027,9.745-4.422,9.718-9.816l-0.361-71.754C98.958,83.781,88.59,73.465,75.908,73.465z"/>
											<path d="M189.203,253.101c-0.957,6.189,3.284,11.983,9.474,12.94c6.204,0.957,11.985-3.296,12.94-9.474l6.243-40.366h-22.95
	L189.203,253.101z"/>
											<path d="M160.3,216.201h-22.95l6.243,40.366c0.866,5.602,5.695,9.609,11.193,9.609c7.003,0,12.278-6.238,11.221-13.075
	L160.3,216.201z"/>
											<path d="M177.646,100.806c10.824,0,19.586-8.77,19.586-19.586c0-10.816-8.768-19.586-19.586-19.586
	c-10.817,0-19.586,8.768-19.586,19.586C158.061,92.062,166.851,100.806,177.646,100.806z"/>
											<path d="M294.856,185.995h-4.984c2.753,0,4.984-2.231,4.984-4.984c0-16.186,0-22.665,0-30.01c0-2.753-2.231-4.984-4.984-4.984
	H283.4v-9.758c0-1.851-1.501-3.352-3.352-3.352h-22.459c-1.851,0-3.352,1.501-3.352,3.352v9.758h-6.471
	c-2.534,0-4.622,1.893-4.938,4.341c-0.072,0.556-0.046-1.395-0.046,30.653c0,2.753,2.231,4.984,4.984,4.984h-45.195v-11.876
	l27.674-12.19c4.661-2.053,6.857-7.431,4.964-12.16c-2.385-5.97-8.35-19.569-13.703-30.575
	c-3.587-7.378-11.208-12.145-19.414-12.145c-22.081,0-27.606,0-51.844,0c-2.137,0-4.209,0.723-5.881,2.053l-28.165,22.394
	c-1.716,1.365-2.905,3.284-3.361,5.428l-7.806,36.638c-1.245,5.844,3.203,11.421,9.252,11.421c4.453,0,8.307-3.137,9.233-7.483
	l7.099-33.321l21.896-17.41v59.225h-45.252c-2.285,0-4.138,1.853-4.138,4.138v14.96c0,2.285,1.853,4.138,4.138,4.138h4.583v6.971
	v52.127c0,2.285,1.852,4.138,4.138,4.138h14.959c2.285,0,4.138-1.853,4.138-4.138v-52.127v-6.971h130.972v6.971v52.127
	c0,2.285,1.853,4.138,4.138,4.138h14.959c2.285,0,4.138-1.853,4.138-4.138v-52.127v-6.971h5.565c2.285,0,4.137-1.851,4.138-4.136
	c0-0.001,0-0.001,0-0.003v-14.96c0.001,0.001,0.001-0.001,0.001-0.001C298.992,187.846,297.14,185.995,294.856,185.995z
	 M202.571,127.907c0-0.475,0.328-0.888,0.792-0.995c0.464-0.107,0.939,0.12,1.147,0.548c3.23,6.641,6.822,14.545,9.598,20.924
	l-11.537,5.082V127.907z M276.696,146.016h-15.755v-6.406h15.755V146.016z"/>
										</svg>
										<div className="text-sm font-bold">{highLightContentData ? highLightContentData[0]?.title : null} {highLightContentData ? highLightContentData[0]?.subTitle : null}</div>
									</div>
									<div className={`flex flex-col justify-around py-5 items-center secondary-${color} rounded`}>
										<svg width="100" height="100"
											viewBox="0 0 24 24" id="layer" fill="none" >
											<path d="M22 12C22 13.3132 21.7413 14.6136 21.2388 15.8268C20.7362 17.0401 19.9997 18.1425 19.0711 19.0711C18.1425 19.9997 17.0401 20.7362 15.8268 21.2388C14.6136 21.7413 13.3132 22 12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C4.00035 18.1425 3.26375 17.0401 2.7612 15.8268C2.25866 14.6136 2 13.3132 2 12C2 10.6868 2.25866 9.38642 2.76121 8.17316C3.26375 6.95991 4.00035 5.85752 4.92893 4.92893C5.85752 4.00035 6.95991 3.26375 8.17317 2.7612C9.38642 2.25866 10.6868 2 12 2C13.3132 2 14.6136 2.25866 15.8268 2.76121C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12L22 12Z" stroke={primary} stroke-width="1.5" />
											<path d="M16 12C16 13.3132 15.8965 14.6136 15.6955 15.8268C15.4945 17.0401 15.1999 18.1425 14.8284 19.0711C14.457 19.9997 14.016 20.7362 13.5307 21.2388C13.0454 21.7413 12.5253 22 12 22C11.4747 22 10.9546 21.7413 10.4693 21.2388C9.98396 20.7362 9.54301 19.9997 9.17157 19.0711C8.80014 18.1425 8.5055 17.0401 8.30448 15.8268C8.10346 14.6136 8 13.3132 8 12C8 10.6868 8.10346 9.38642 8.30448 8.17316C8.5055 6.95991 8.80014 5.85752 9.17157 4.92893C9.54301 4.00035 9.98396 3.26375 10.4693 2.7612C10.9546 2.25866 11.4747 2 12 2C12.5253 2 13.0454 2.25866 13.5307 2.76121C14.016 3.26375 14.457 4.00035 14.8284 4.92893C15.1999 5.85752 15.4945 6.95991 15.6955 8.17317C15.8965 9.38642 16 10.6868 16 12L16 12Z" stroke={primary} stroke-width="1.5" />
											<path d="M2 12H22" stroke={primary} stroke-width="1.5" stroke-linecap="round" />
										</svg>
										<div className="text-sm font-bold">{highLightContentData ? highLightContentData[1]?.title : null} {highLightContentData ? highLightContentData[1]?.subTitle : null}</div>
									</div>
									<div className={`flex flex-col justify-around py-5 items-center secondary-${color} rounded`}>
										<svg width="100" height="100" fill="none" viewBox="0 0 24 24" id="layer" >
											<path d="M7.2998 5H22L20 12H8.37675M21 16H9L7 3H4M4 8H2M5 11H2M6 14H2M10 20C10 20.5523 9.55228 21 9 21C8.44772 21 8 20.5523 8 20C8 19.4477 8.44772 19 9 19C9.55228 19 10 19.4477 10 20ZM21 20C21 20.5523 20.5523 21 20 21C19.4477 21 19 20.5523 19 20C19 19.4477 19.4477 19 20 19C20.5523 19 21 19.4477 21 20Z" stroke={primary} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
										</svg>
										<div className="text-sm font-bold">{highLightContentData ? highLightContentData[2]?.title : null} {highLightContentData ? highLightContentData[2]?.subTitle : null}</div>
									</div>
									<div className={`flex flex-col justify-around py-5 items-center secondary-${color} rounded`}>
										<svg fill={primary} version="1.1" id="Capa_1" width="100" height="100" viewBox="0 0 612 612">
											<path d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078
C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541
c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z
 M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812
c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812
h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16
c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z
 M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539
c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751
c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907
c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29
l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697
c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347
C565.257,281.569,563.532,285.839,560.084,285.839z"/>
										</svg>
										<div className="text-sm font-bold">{highLightContentData ? highLightContentData[3]?.title : null} {highLightContentData ? highLightContentData[3]?.subTitle : null}</div>
									</div>
								</div>
							</div>
							<div className="w-full flex items-center justify-center flex-col h-max   border-y border-black border-opacity-20">
								<div className={`flex flex-col justify-center items-center w-full  secondary-${color}`}>
									<div className="flex flex-col justify-center items-center my-10">
										<div className="uppercase font-bold ">{promiseContentHeading ? promiseContentHeading[0]?.title : null}</div>
									</div>
									<div className="flex flex-col justify-center item-center space-y-5 my-5">
										<div className={`w-[250px]  flex flex-col h-max items-center justify-center py-3  primary-${color} shadow-xl rounded-xl`}>
											<div>
												<svg fill={secondary} height="100" width="100" version="1.1" id="Capa_1" viewBox="0 0 490 490">
													<path d="M232.582,75.479c-93.474,0-169.521,76.049-169.521,169.521c0,93.474,76.047,169.519,169.521,169.519
c93.473,0,169.519-76.046,169.519-169.519C402.101,151.527,326.055,75.479,232.582,75.479z M364.829,302.657
c-12.73,5.033-26.869,9.256-42.051,12.604c2.236-18.367,3.585-37.736,3.988-57.643h49.541
C374.925,273.502,370.957,288.655,364.829,302.657z M88.856,257.618h49.539c0.402,19.902,1.751,39.266,3.986,57.628
c-15.183-3.348-29.322-7.565-42.047-12.588C94.206,288.656,90.239,273.502,88.856,257.618z M100.336,187.338
c12.735-5.034,26.876-9.257,42.064-12.605c-2.242,18.391-3.6,37.768-4.004,57.648h-49.54
C90.239,216.496,94.206,201.342,100.336,187.338z M245.2,165.671c17.799,0.471,35.1,1.936,51.528,4.33
c2.714,19.603,4.341,40.617,4.797,62.38H245.2V165.671z M245.2,140.428v-39.154c13.385,1.165,26.252,4.165,38.35,8.748
c3.367,10.412,6.296,21.787,8.762,33.925C277.116,142.021,261.329,140.836,245.2,140.428z M219.964,140.428
c-16.125,0.407-31.905,1.592-47.097,3.516c2.464-12.141,5.39-23.516,8.751-33.924c12.097-4.582,24.963-7.581,38.346-8.746V140.428z
M219.964,165.671l0.001,66.71h-56.327c0.457-21.728,2.092-42.752,4.813-62.384C184.876,167.605,202.169,166.141,219.964,165.671z
M163.637,257.618h56.328l0.001,66.711c-17.771-0.473-35.082-1.938-51.535-4.341C165.718,300.389,164.092,279.378,163.637,257.618z
M219.966,349.57v39.155c-13.387-1.165-26.254-4.165-38.352-8.749c-3.369-10.415-6.3-21.795-8.767-33.938
C188.061,347.971,203.854,349.162,219.966,349.57z M245.202,349.571c16.129-0.407,31.914-1.593,47.11-3.519
c-2.466,12.137-5.396,23.512-8.761,33.924c-12.098,4.584-24.965,7.583-38.35,8.749V349.571z M245.202,324.329l-0.002-66.711h56.325
c-0.456,21.763-2.081,42.778-4.797,62.382C280.3,322.395,263.001,323.858,245.202,324.329z M326.767,232.381
c-0.403-19.907-1.752-39.276-3.988-57.644c15.182,3.349,29.319,7.571,42.051,12.604c6.128,14.003,10.096,29.156,11.478,45.039
H326.767z M344.57,154.136c-8.272-2.254-16.886-4.245-25.778-5.966c-1.368-7.613-2.9-14.988-4.595-22.084
C325.612,133.945,335.847,143.404,344.57,154.136z M150.977,126.078c-1.692,7.097-3.227,14.472-4.594,22.086
c-8.896,1.722-17.511,3.714-25.788,5.968C129.323,143.398,139.558,133.939,150.977,126.078z M120.589,335.857
c8.273,2.251,16.887,4.244,25.778,5.965c1.368,7.615,2.901,14.992,4.596,22.088C139.546,356.05,129.313,346.592,120.589,335.857z
M314.199,363.912c1.692-7.094,3.226-14.469,4.593-22.081c8.895-1.722,17.506-3.714,25.778-5.968
C335.847,346.596,325.614,356.053,314.199,363.912z"/>
													<path d="M489.36,233.99c-1.15-2.516-3.66-4.129-6.428-4.129h-17.951c-3.603-56.469-27.298-109.063-67.67-149.434
C353.353,36.468,294.906,12.26,232.74,12.26S112.128,36.468,68.169,80.428C24.209,124.387,0,182.833,0,245
c0,62.166,24.209,120.611,68.169,164.571c43.959,43.96,102.404,68.169,164.571,68.169c52.738,0,104.401-18.133,145.472-51.055
c5.439-4.359,6.313-12.301,1.953-17.738c-4.357-5.436-12.297-6.312-17.737-1.953c-37.14,29.773-81.986,45.51-129.688,45.51
c-114.417,0-207.504-93.087-207.504-207.504c0-114.418,93.087-207.504,207.504-207.504c109.327,0,199.169,84.988,206.948,192.365
h-16.896c-2.764,0-5.277,1.613-6.427,4.129c-1.149,2.515-0.726,5.47,1.084,7.562l30.068,34.746
c1.342,1.552,3.292,2.442,5.343,2.442c2.053,0,4.001-0.891,5.344-2.441l30.072-34.746
C490.086,239.461,490.511,236.505,489.36,233.99z"/>
												</svg>
											</div>
											<div className="w-[200px] font-semibold text-sm text-center px-3 py-3 ">{promiseContentData ? promiseContentData[0]?.title : null} </div>
											<div className="w-[250px] text-xs main text-center px-3 rounded min-h-12">{promiseContentData ? promiseContentData[0]?.subTitle : null}</div>
										</div>
										<div className={`w-[250px] flex flex-col items-center justify-center py-3 primary-${color}  shadow-xl rounded-xl`}>
											<div className="">
												<svg fill={secondary} width="100" height="100" viewBox="0 0 50 50">
													<path d="M4 1C3.447 1 3 1.448 3 2L3 10C3 10.553 3.447 11 4 11L15 11C15.553 11 16 10.553 16 10L16 2C16 1.448 15.553 1 15 1L4 1 z M 37.164062 9.5C35.289759 9.5 33.707216 10.100433 32.857422 11L27 11 A 1.0001 1.0001 0 1 0 27 13L32.259766 13C32.645045 14.435874 34.65739 15.5 37.164062 15.5C38.270063 15.5 38.997172 15.287031 39.451172 14.832031C40.016172 14.264031 40.014719 13.463453 40.011719 12.689453L40.009766 12.498047L40.011719 12.308594C40.014719 11.535594 40.017172 10.735969 39.451172 10.167969C38.997172 9.7119687 38.272922 9.5 37.169922 9.5L37.164062 9.5 z M 2 13C1.447 13 1 13.448 1 14L1 22C1 22.552 1.447 23 2 23L11.015625 23C11.141625 21.347 12.102 19.217484 14 19.021484L14 14C14 13.448 13.553 13 13 13L2 13 z M 33.248047 16.685547C34.111047 23.246547 32.823125 29.604359 29.828125 33.193359C28.272125 35.056359 26.401578 36 24.267578 36C23.280578 36 22.695906 35.350687 22.378906 34.804688C21.522906 33.329687 21.375734 30.4365 23.302734 26.5625C22.012734 26.8515 20.394547 27 18.435547 27C17.257114 27 14.548266 26.991755 12.748047 26.035156C12.564418 25.937694 12.392472 25.829279 12.230469 25.710938C11.915435 25.480918 11.640065 25.214349 11.435547 24.894531C11.363467 24.927922 11.299313 24.965842 11.228516 25L1 25C0.447 25 0 25.448 0 26C0 26.553 0.447 27 1 27L8.140625 27C5.1303891 29.545041 4.0970005 32.516944 4.0371094 32.726562C3.9621094 32.992562 3.9995781 33.278625 4.1425781 33.515625C4.2855781 33.752625 4.5190625 33.920516 4.7890625 33.978516L19.869141 38L31.058594 38C31.023594 37.69 31 37.362 31 37C31 31.673 36.14 27 42 27C42.181 27 42.352391 27.009578 42.525391 27.017578C42.167391 23.010578 40.234813 19.650906 38.507812 17.378906C38.093812 17.451906 37.653062 17.5 37.164062 17.5C35.690063 17.5 34.351047 17.202547 33.248047 16.685547 z M 14.28125 21C14.184077 21 14.090938 21.029755 14 21.076172C13.998509 21.076936 13.997583 21.079303 13.996094 21.080078C13.882067 21.139256 13.775918 21.234863 13.675781 21.351562C13.662059 21.367468 13.648179 21.381642 13.634766 21.398438C13.535952 21.522709 13.444734 21.665208 13.365234 21.828125C13.265172 22.032233 13.18821 22.260101 13.126953 22.494141C13.107622 22.56791 13.098893 22.636507 13.083984 22.710938C13.064878 22.805995 13.03673 22.899883 13.025391 22.994141C13.033791 22.993923 13.04048 22.988703 13.048828 22.988281C13.033436 23.115491 13 23.246564 13 23.367188C13 24.385188 14.858547 25 18.435547 25C22.014547 25 25 24.386188 25 23.367188C25 22.350188 24.426797 21 23.716797 21L14.28125 21 z M 42 29C37.475 29 33 32.574 33 37C33 39.74 34.19 40 35 40C36.659 40 36 36.598 40 35C41.175 34.531 42.330391 34.384766 43.400391 34.384766C45.209391 34.384766 46.774109 34.804688 47.787109 34.804688C48.552109 34.804688 49.001953 34.564703 49.001953 33.720703C49.000953 32.999703 47.704 29 42 29 z M 43.179688 36.392578C42.282688 36.414578 41.479187 36.563422 40.742188 36.857422C40.554187 36.932422 40.385562 37.012703 40.226562 37.095703C40.087562 37.369703 40 37.673 40 38C40 39.103 40.897 40 42 40C43.103 40 44 39.103 44 38C44 37.339 43.674687 36.756578 43.179688 36.392578 z M 6.1933594 36.421875C6.0743594 36.937875 6 37.465 6 38C6 41.859 9.141 45 13 45C16.172 45 18.853938 42.876516 19.710938 39.978516C19.590938 39.969516 19.470516 39.964594 19.353516 39.933594L16.78125 39.246094C16.25425 40.839094 14.768 42 13 42C10.794 42 9 40.206 9 38C9 37.723 9.0348437 37.454359 9.0898438 37.193359L6.1933594 36.421875 z M 45.732422 36.59375C45.898422 37.03375 46 37.504 46 38C46 40.206 44.206 42 42 42C40.262 42 38.795141 40.880125 38.244141 39.328125C38.220141 39.376125 38.196828 39.424656 38.173828 39.472656C37.816828 40.207656 37.264 41.317297 36.125 41.779297C37.384 43.731297 39.565 45 42 45C45.859 45 49 41.859 49 38C49 37.545 48.940516 37.096297 48.853516 36.654297C48.534516 36.742297 48.190156 36.804688 47.785156 36.804688C47.208156 36.804688 46.583875 36.715141 45.921875 36.619141C45.861875 36.610141 45.793422 36.60275 45.732422 36.59375 z M 11.029297 37.712891C11.015297 37.807891 11 37.902 11 38C11 39.103 11.897 40 13 40C13.843 40 14.562469 39.472422 14.855469 38.732422L11.029297 37.712891 z" />
												</svg>
											</div>
											<div className="w-[200px] font-semibold text-sm text-center px-3 py-3 ">{promiseContentData ? promiseContentData[1]?.title : null} </div>
											<div className="w-[250px] text-xs  main text-center px-3  rounded  min-h-12">{promiseContentData ? promiseContentData[1]?.subTitle : null}o</div>
										</div>
										<div className={`w-[250px] flex flex-col items-center justify-center primary-${color}  shadow-xl rounded-xl`}>
											<div>
												<svg width="100" height="100" viewBox="0 0 1024 1024" fill={secondary} className="icon" version="1.1"><path d="M107.19232 617.00096h562.14528v77.76256H260.36224c-12.19584-33.49504-44.34944-57.4976-82.0224-57.4976-37.10976 0-68.864 23.296-81.46944 56.02304a37.2224 37.2224 0 0 1-26.90048-35.74784v-3.30752a37.2224 37.2224 0 0 1 37.2224-37.23264z m133.20192 98.85696a65.024 65.024 0 0 1-64.95232 64.94208c-35.79904 0-64.94208-29.1328-64.94208-64.94208s29.14304-64.95232 64.94208-64.95232a65.024 65.024 0 0 1 64.95232 64.95232z m-19.8656 0a45.13792 45.13792 0 0 0-45.08672-45.08672c-24.86272 0-45.07648 20.23424-45.07648 45.08672s20.224 45.07648 45.07648 45.07648a45.11744 45.11744 0 0 0 45.08672-45.07648z m676.32128 0c0 35.80928-29.14304 64.94208-64.95232 64.94208s-64.94208-29.1328-64.94208-64.94208 29.1328-64.95232 64.94208-64.95232 64.95232 29.14304 64.95232 64.95232z m-19.85536 0c0-24.86272-20.23424-45.08672-45.08672-45.08672s-45.07648 20.23424-45.07648 45.08672 20.224 45.07648 45.07648 45.07648 45.08672-20.21376 45.08672-45.07648zM991.56992 529.3056v146.8416c0 6.85056-5.56032 12.41088-12.41088 12.41088h-64.88064c-13.74208-30.21824-44.17536-51.3024-79.48288-51.3024s-65.75104 21.08416-79.49312 51.3024h-43.776a12.41088 12.41088 0 0 1-12.41088-12.41088V381.22496c0-6.8608 5.56032-12.41088 12.41088-12.41088h163.38944c6.85056 0 17.27488 2.28352 24.82176 12.41088l91.83232 148.08064z m-57.9072-32.26624l-55.83872-92.66176c-4.31104-7.97696-9.61536-12.40064-28.54912-12.40064H747.9296c-6.85056 0-12.41088 5.55008-12.41088 12.40064v92.66176c0 6.8608 5.56032 12.41088 12.41088 12.41088h173.32224c6.85056 0 12.41088-5.55008 12.41088-12.41088z m48.384 141.04576a11.58144 11.58144 0 0 0-23.16288 0v21.93408a11.58144 11.58144 0 0 0 23.16288 0v-21.93408zM32.43008 594.78016h636.90752V243.2H32.43008v351.58016z" /></svg>
											</div>
											<div className="w-[200px] font-semibold text-sm text-center  px-3 ">{promiseContentData ? promiseContentData[2]?.title : null} </div>
											<div className="w-[250px] text-xs main text-center p-3 rounded min-h-12 ">{promiseContentData ? promiseContentData[2]?.subTitle : null}</div>
										</div>
										<div className={`w-[250px] flex flex-col items-center  primary-${color} justify-center shadow-xl rounded-xl`}>
											<div className="">
												<svg fill={secondary} height="100" width="100" version="1.1" id="Capa_1" viewBox="0 0 490 490">
													<circle cx="158.808" cy="191.789" r="14.446" />
													<path d="M449.228,91.881c-18.694,0-34.436,12.584-39.249,29.74h-18.343c-6.092,0-11.03,4.938-11.03,11.029
c0,6.094,4.938,11.031,11.03,11.031h18.343c4.813,17.156,20.555,29.74,39.249,29.74c22.517,0,40.772-18.252,40.772-40.771
C490,110.135,471.745,91.881,449.228,91.881z"/>
													<path d="M449.824,186.672c-10.619,0-20.052,5.064-26.027,12.904c-3.183,3.711-14.34,15.705-28.986,20.158
c-15.983,4.859-32.241-3.533-32.323-3.576c-6.941-3.764-15.609-1.188-19.372,5.748c-3.76,6.938-0.862,15.066,5.75,19.371
c13.889,9.039,41.815,9.578,54.258,5.797c5.011-1.523,9.69-3.568,13.992-5.881v69.73c0,10.506,4.957,19.846,12.653,25.83v127.914
c0,11.076,8.979,20.055,20.056,20.055c11.077,0,20.057-8.979,20.057-20.055V336.754c7.696-5.984,12.652-15.326,12.652-25.83
v-91.543C482.533,201.316,467.89,186.672,449.824,186.672z"/>
													<path d="M354.974,204.584c11.248,0,15.301,6.238,26.073,6.238c6.088,0,13.171-2.184,13.171-5.445v-23.178
c0-8.082-6.576-14.658-14.658-14.658h-42.08v19.133c0,1.385-1.122,2.506-2.507,2.506H322.96c-1.385,0-2.508-1.121-2.508-2.506
v-19.133h-42.079c-8.082,0-14.658,6.576-14.658,14.658v101.188c0,8.082,6.576,14.658,14.658,14.658H379.56
c8.082,0,14.658-6.576,14.658-14.658v-20.158c0-0.727-0.315-1.416-0.862-1.893c-0.547-0.475-1.271-0.648-1.992-0.59
c-47.621,3.824-69.433-21.543-58.5-43.002C337.056,209.516,345.739,204.584,354.974,204.584z"/>
													<path d="M256.081,348.221h-20.308V20.318c0-8.307-6.735-15.041-15.043-15.041H45.377c-8.307,0-15.041,6.734-15.041,15.041v327.902
H10.027C4.489,348.221,0,352.709,0,358.248v35.514c0,5.539,4.489,10.027,10.027,10.027h246.054c5.538,0,10.028-4.488,10.028-10.027
v-35.514C266.109,352.709,261.619,348.221,256.081,348.221z M60.42,35.361h145.269v312.855H60.42V35.361z"/>
												</svg>
											</div>
											<div className="w-[200px] font-semibold text-sm text-center px-3  ">{promiseContentData ? promiseContentData[3]?.title : null} </div>
											<div className="w-[250px] text-xs  main text-center p-3  rounded min-h-12">{promiseContentData ? promiseContentData[3]?.subTitle : null}</div>
										</div>
									</div>
								</div>
							</div>
							<div className={`w-full flex items-center py-5 justify-center flex-col h-max border-y secondary-${color} border-black border-opacity-20`}>
								<div className="flex flex-col justify-center items-center w-full">
									<div className="flex flex-col justify-center items-center mt-10 w-full">
										<div className=" uppercase font-bold my-5">{workContentHeading ? workContentHeading[0]?.title : null}</div>
									</div>
								</div>
								<div className="flex flex-col justify-center space-y-5">
									<div className={`flex justify-center  secondary-${color} flex-col items-center rounded shadow-xl w-64 h-56`}>
										<svg width="100" height="100" viewBox="0 0 512 512">
											<path fill={primary} d="M268.383 22.168l-55.918 84.482 29.717 3.733c-9.22 30.13-11.095 50.878-8.885 92.12 14.138-2.23 25.56-3.025 40.586 1.39-9.877-36.84-8.844-49.427-4.88-89.768l32.622 2.277-33.242-94.234zm218.482 2.21l-108.36 30.03 20.915 25.975c-49.512 31.019-80.331 55.548-104.74 123.164 13.201-.152 28.098 2.921 44.174 9.004 5.728-44.666 33.74-76.14 79.302-108.918l19.983 24.816 48.726-104.07zm-463.574 2.31L89.17 129.173l19.084-28.711c35.554 32.44 58.145 76.33 57.308 107.43 18.568-8.696 29.927-9.527 49.735-3.778-8.105-31.203-43.577-108.722-91.639-129.103l16.57-26.037L23.292 26.687zm276.117 214.667c-5.28.12-10.21 2.415-16.937 9.594l-6.565 6.969-6.812-6.72c-7.387-7.28-13.216-9.29-19.125-9.03-5.908.26-12.855 3.367-20.625 9.656l-6.217 5.03-5.906-5.374c-8.9-8.052-16.485-10.439-23.75-10.064-5.288.274-10.775 2.266-16.25 5.75l40.966 73.69c15.454 9.451 47.034 13.006 68.75 2.062l39.594-73.344c-7.51-3.062-14.26-6.202-20.094-7.406-2.112-.437-4.07-.756-5.968-.813-.354-.01-.71-.008-1.06 0zm-89.97 96.188v.002c-18.035 12.742-32.516 34.717-38.125 66.904-5.435 31.196 3.129 52.266 18.283 66.625 15.155 14.36 37.902 21.736 61 21.436 23.1-.3 46.136-8.31 61.625-22.936 15.49-14.627 24.249-35.425 19.281-65.187-5.137-30.757-18.4-52.148-35.19-65.094-28.482 15.056-64.095 11.856-86.875-1.75z" />
										</svg>
										<div className="text-sm font-bold  py-2">{workContentData ? workContentData[0]?.title : null}</div>
										<div className="text-xs  px-8 py-2 text-center">{workContentData ? workContentData[0]?.subTille : null}</div>
									</div>
									<div className={`flex justify-center secondary-${color} flex-col items-center  rounded shadow-xl  w-64 h-56`}>
										<svg width="100" height="100" viewBox="0 0 20 20">
											<path fill={primary} d="M2.84210526,3.86504044 L2.84210526,11.2988054 C2.84210526,15.3455734 6.0468039,18.6261272 10,18.6261272 C13.9531961,18.6261272 17.1578947,15.3455734 17.1578947,11.2988054 L17.1578947,3.86837364 L9.9567671,1.44685758 L2.84210526,3.86504044 Z M9.95451486,0 L18.5,2.87358183 L18.5,11.2988054 C18.5,16.1043425 14.6944204,20 10,20 C5.30557963,20 1.5,16.1043425 1.5,11.2988054 L1.5,2.87358183 L9.95451486,0 Z M14.3737014,6.48544473 C14.0967483,6.23334258 13.6725898,6.25880251 13.4263169,6.54231108 L13.4263169,6.54231108 L9.11047784,11.5106915 L6.32211371,8.42587388 C6.07040936,8.1474088 5.64584183,8.13054472 5.37381559,8.38820691 C5.10178936,8.6458691 5.08531523,9.08048613 5.33701959,9.35895121 L5.33701959,9.35895121 L8.62781212,12.9996145 C8.89702337,13.2974478 9.35842515,13.2927747 9.62182714,12.9895471 L9.62182714,12.9895471 L14.4292528,7.45525373 C14.6755257,7.17174516 14.6506545,6.73754688 14.3737014,6.48544473 Z" />
										</svg>
										<div className="text-sm font-bold py-2">{workContentData ? workContentData[1]?.title : null}</div>
										<div className="text-xs  px-8 py-2 text-center">{workContentData ? workContentData[1]?.subTille : null}</div>
									</div>
									<div className={`flex justify-center secondary-${color} flex-col items-center   rounded shadow-xl  w-64 h-56`}>
										<svg fill={primary} width="100" height="100" version="1.1" id="Layer_1" viewBox="0 0 496 496">
											<path d="M144,144H32v112h112V144z M128,240H48v-80h80V240z" />
											<path d="M272,144H160v112h112V144z M256,240h-80v-80h80V240z" />
											<path d="M144,272H32v112h112V272z M128,368H48v-80h80V368z" />
											<path d="M272,272H160v112h112V272z M256,368h-80v-80h80V368z" />
											<polygon points="80,224 96,224 96,208 112,208 112,192 96,192 96,176 80,176 80,192 64,192 64,208 80,208 			" />
											<rect x="192" y="192" width="48" height="16" />
											<polygon points="69.656,357.656 88,339.312 106.344,357.656 117.656,346.344 99.312,328 117.656,309.656 106.344,298.344 
	88,316.688 69.656,298.344 58.344,309.656 76.688,328 58.344,346.344 			"/>
											<rect x="192" y="304" width="48" height="16" />
											<rect x="192" y="336" width="48" height="16" />
											<rect x="256" y="80" width="16" height="16" />
											<rect x="32" y="80" width="208" height="16" />
											<path d="M464,432H53.784L0.456,464l53.328,32H464c17.648,0,32-14.352,32-32S481.648,432,464,432z M384,480H58.216l-26.672-16
	l26.672-16H384V480z M416,480h-16v-32h16V480z M464,480h-32v-32h32c8.816,0,16,7.176,16,16C480,472.824,472.816,480,464,480z"/>
											<path d="M304,48V0H0v416h304v-48h192V48H304z M288,400H16V128h272V400z M288,112H16V16h272V112z M480,352H304V64h176V352z" />
											<path d="M387.704,334.752l4.296,2.736l4.296-2.736C399.064,332.984,464,290.648,464,208S399.064,83.016,396.296,81.248
	L392,78.512l-4.296,2.736C384.936,83.016,320,125.352,320,208S384.936,332.984,387.704,334.752z M392.016,97.848
	c8.776,6.728,29,24.344,42.584,52.24C422.656,141.28,407.952,136,392,136c-15.912,0-30.584,5.248-42.512,14.016
	C363.08,122.224,383.256,104.592,392.016,97.848z M392,152c30.872,0,56,25.128,56,56s-25.128,56-56,56s-56-25.128-56-56
	S361.128,152,392,152z M392,280c15.912,0,30.576-5.248,42.512-14.016c-13.6,27.792-33.776,45.424-42.528,52.168
	c-8.776-6.728-29-24.344-42.584-52.24C361.344,274.72,376.048,280,392,280z"/>
											<polygon points="384,248 400,248 400,216 432,216 432,200 400,200 400,168 384,168 384,200 352,200 352,216 384,216 			" />
										</svg>
										<div className="text-sm font-bold py-2">{workContentData ? workContentData[2]?.title : null}</div>
										<div className="text-xs px-8 py-2 text-center">{workContentData ? workContentData[2]?.subTille : null}</div>
									</div>
								</div>
							</div>
							<div className={`w-full flex flex-col items-center py-5  secondary-${color}  border-y border-black border-opacity-20`}>
								<div className="flex flex-col w-full text-md px-5">
									<div className="text-2xl font-bold py-3 uppercase">{partnerConentData ? partnerConentData[0]?.title : null}</div>
									<div className="text-md text-justify">{partnerConentData ? partnerConentData[0]?.description : null}
									</div>
								</div>
								<div className="flex w-full justify-center items-center p-2">
									{partnerConentData && partnerConentData[0]?.src ? <img src={partnerConentData[0]?.src} width="600" height="300" />
										: <img src={'https://via.placeholder.com/1000x337'} width="600" height="300" />}
								</div>
							</div>
							<div className={`flex flex-col w-full primary-${color} `}>
								<div className="flex flex-col space-y-5 p-10 w-scre en">
									<div className={`w-full italic text-2xl  terirary-${color}`} >
										<div className="border-0"><img src={logo?.logoDark[0]?.Url} className=" w-24" /></div>
										<div className="text-sm  text-justify">{aboutUsHeading ? aboutUsHeading[0]?.shortDescription : null}</div>
									</div>
									<div className={`w-full terirary-${color}  uppercase flex flex-col justify-center item-center text-sm`}>
										<div>Get to Know Us</div>
										<div className="text-[10px] space-y-2 pl-5 py-2">
											<div onClick={() => handleNavigate('/about-us')}> About Us</div>
											<div> Contact Us</div>
										</div>
									</div>
									<div className={`w-full terirary-${color}  uppercase flex flex-col justify-center item-center text-sm`}>
										<div>Platforms</div>
										<div className="text-[10px] space-y-2 pl-5 py-2">
											<div onClick={() => handleNavigate('/auth/login/transporter')}> Transporter Login</div>
											<div onClick={() => handleNavigate('/auth/login/transport-agent')}> Transport Agent Login</div>
											<div onClick={() => handleNavigate('/auth/login/management')}> Management Login</div>
										</div>
									</div>

									<div className={`w-full terirary-${color} uppercase flex flex-col justify-center item-center text-sm`}>
										<div>{domesticCourierHeading ? domesticCourierHeading[0]?.title : null}</div>
										{domesticCourierContent ? <div className="text-[10px] space-y-2 pl-5 py-2">
											{domesticCourierContent.map((content: any) =>

												<div>{content?.title}</div>
											)}

											<div> ...</div>
										</div> : null}
									</div>
									<div className={`w-full terirary-${color} uppercase flex flex-col justify-center item-center text-sm`}>
										<div>{internationalCourierHeading ? internationalCourierHeading[0]?.title : null}</div>
										{internationalCourierContent ? <div className="text-[10px] space-y-2 pl-5 py-2">
											{internationalCourierContent.map((content: any) =>

												<div>{content?.title}</div>
											)}
										</div> : null}
									</div>
									<div className={`w-full terirary-${color}  uppercase flex flex-col justify-center item-center text-sm`}>
										<div>Help</div>
										<div className="text-[10px] space-y-2 pl-5 py-2">
											<div> Track</div>
										</div>
									</div>
								</div>
								<div className={`w-screen  flex flex-col  px-8 py-6 justify-between items-end  bottom-0 secondary-${color} `}>
									<p className="mb-2 mb-0 text-xs">{copyRightsContent ? copyRightsContent[0].title : null}</p>
									<div className="flex">
										<a href="#" className="mr-3  text-xs">Terms of Service &nbsp;&nbsp; |</a>
										<a href="#" className="mr-3 text-xs">Privacy Policy &nbsp;&nbsp; |</a>
										<a href="#" className=" text-xs">About Us</a>
									</div>
								</div>
							</div>
						</div>

					</div > :
						<div className={`flex flex-col items-center justify-center w-full primary-${color}`}>
							<GetQuote />

							<div className="flex justify-around items-center p-1 w-full h-[600px] px-10">
								<div className="flex flex-col justify-between items-center w-1/2">
									<Carousel
										autoPlay
										infiniteLoop
										showStatus={false}
										showIndicators={false}
										showThumbs={false}>
										{sliderData?.map((banner: any) => (
											<div>
												<img src={banner?.src} />
											</div>
										))}

									</Carousel>
									<div className="w-full flex justify-center items-start">
										<div className="absolute fixed w-1/3 text-2xl   italic z-10 inset-30 mt-20 flex items-center justify-center text-center">
											<div className=" rounded-3xl p-3 px-4 shadow-xl  border-x border-y ">Meet the World Largest Leading Global Logistic</div>
										</div>
										<img src={require('./../../../assets/img/worldmap.png')} className="w-[300px] h-64 brightness-75	   " />
									</div>
								</div>
								<div className={`w-1/3 justify-center item-center rounded-xl secondary-${color}`}>
									<div className="w-full p-5 flex flex-col justify-center items-center rounded-xl">
										<div className="uppercase font-bold py-5">Instant Quote Calculator</div>
										<div className=" w-full px-3 font-bold space-y-2">
											<div className="flex flex-row ">
												<div className=" w-full text-xs flex flex-row justify-start items-center">
													<input
														type="checkbox"
														name={"from"}
														placeholder=""
														className={`px-2 teritary-${color} text-xs px-3`}
														onChange={(event) => {
															handleChange(
																event.target.checked,
																'IsExistingUser'
															)
														}}
														value={leadValues?.IsExistingUser}
													/>
													<div className="mx-2">Are You Already Register?</div>
												</div>
											</div>
											{!leadValues?.IsExistingUser ? <>
												<div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Name
														</label>
														<div className="border-0  text-xs ">
															<input
																type="text"
																name={"Name"}
																placeholder="Enter the Full Name"
																className={`w-full py-1 teritary-${color} bg-opacity-0 text-xs px-3`}
																onChange={(event) => {
																	handleChange(
																		event.target.value,
																		'Name'
																	);
																}}
																value={leadValues?.Name} />
														</div>
													</div>
												</div>
												<div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Email
														</label>
														<div className="border-0   text-xs ">
															<input
																type="email"
																name={"Email"}
																placeholder="Enter the Email"
																className={`w-full py-1 teritary-${color} bg-opacity-0 text-xs px-3`}
																onChange={(event) => {
																	handleChange(
																		event.target.value,
																		'Email'
																	);
																}}
																value={leadValues?.Email} />
														</div>
													</div>
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Mobile
														</label>
														<div className="border-0  text-xs ">
															<input
																type="number"
																name={"PhoneNumber"}
																placeholder="Enter the Phone Number"
																className={`w-full py-1  teritary-${color} bg-opacity-0 text-xs px-3`}
																onChange={(event) => {
																	handleChange(
																		event.target.value,
																		'PhoneNumber'
																	);
																}}
																value={leadValues?.PhoneNumber} />
														</div>
													</div>
												</div>
												<div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															From
														</label>
														<div className="border-0   text-xs ">
															<GoogleMapSearch
																setLocation={setSearchedLocation}
																location={searchedLocation}
																placeholder="From Address" />

														</div>
													</div>
												</div>
												<div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															To
														</label>
														<div className="border-0   text-xs ">
															<GoogleMapSearch
																setLocation={setSearchedToLocation}
																location={searchedToLocation}
																placeholder="To Address" />
														</div>
													</div>
												</div>
												<div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Schedule Date
														</label>
														<div className="border-0   text-xs ">
															<input
																type="date"
																name={"frodatem"}
																min={new Date().toISOString().split("T")[0]}
																placeholder=""
																className={`w-full py-1 teritary-${color} bg-opacity-0 text-xs px-3`}
																onChange={(event) => {
																	handleChange(
																		event.target.value,
																		'date'
																	);
																}}
																value={leadValues?.date} />
														</div>
													</div>
												</div></> :
												<>
													<div className="flex flex-row space-x-2">
														<div className=" w-full">
															<label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																Login with Email or PhoneNumber
															</label>
															<div className="border-0  text-xs ">
																<input
																	type="text"
																	name={"Email"}
																	placeholder="Login with Email or PhoneNumber"
																	className={`w-full py-1 teritary-${color} bg-opacity-0 text-xs px-3`}
																	onChange={(event) => {
																		handleChange(
																			event.target.value,
																			'Email'
																		);
																	}}
																	value={leadValues?.Email} />
															</div>
														</div>

													</div><div className="flex flex-row space-x-2">
														<div className=" w-full">
															<label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																From
															</label>
															<div className="border-0   text-xs ">
																<GoogleMapSearch
																	setLocation={setSearchedLocation}
																	location={searchedLocation}
																	placeholder="From Address" />
															</div>
														</div>
													</div><div className="flex flex-row space-x-2">
														<div className=" w-full">
															<label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																To
															</label>
															<div className="border-0  bg-[#F3F4F6FF] text-xs ">
																<GoogleMapSearch
																	setLocation={setSearchedToLocation}
																	location={searchedToLocation}
																	placeholder="To Address" />
															</div>
														</div>
													</div><div className="flex flex-row space-x-2">
														<div className=" w-full">
															<label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																Schedule Date
															</label>
															<div className="border-0  bg-[#F3F4F6FF] text-xs ">
																<input
																	type="date"
																	name={"frodatem"}
																	min={new Date().toISOString().split("T")[0]}
																	placeholder=""
																	className="w-full py-1 bg-black bg-opacity-0 text-xs px-3"
																	onChange={(event) => {
																		handleChange(
																			event.target.value,
																			'date'
																		);
																	}}
																	value={leadValues?.date} />
															</div>
														</div>
													</div></>
											}

										</div>
										{/* <div className="text-[#405578]  text-[9px] pt-3">Wrong weight and sized will seized ypur package + Rs500 penality</div> */}

										<div className={`primary-${color} px-5 rounded-3xl flex flex-row space-x-1 flex item-center justify-center mt-5 mb-2 `}>
											<div
												onClick={handleSubmit}
												className=" uppercase text-xs my-3 font-bold cursor-pointer">
												Get Quote
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="w-full flex items-center justify-around flex-col h-max  border-y border-black border-opacity-20">
								<div className={`secondary-${color} w-full py-5 flex flex-row justify-around items-center`}>
									<div className="">
										<svg fill={primary} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
											width="100" height="100" viewBox="0 0 612 612.001"
										>
											<path d="M305.058,329.286V570.82l192.293-36.491V416.644c0-4.926,4.291-8.752,9.185-8.19l23.658,3.661
		c4.162,0.478,7.305,4.001,7.305,8.19v136.717c0,3.885-2.713,7.243-6.512,8.061l-210.5,45.261
		c-10.172,2.188-20.691,2.211-30.873,0.069L81.373,566.609c-3.738-0.786-6.446-4.037-6.545-7.854L71.23,419.907
		c-0.112-4.354,3.181-8.046,7.521-8.427l176.886-15.543c3.068-0.269,5.73-2.226,6.902-5.074l26.648-64.716
		C292.628,317.796,305.058,320.254,305.058,329.286z M69.23,250.204L13.721,368.855c-2.713,5.798,1.928,12.34,8.297,11.697
		l208.464-21.064c2.946-0.298,5.505-2.152,6.707-4.858l67.075-151.111l-229.056,42.07C72.587,246.071,70.36,247.79,69.23,250.204z
		 M304.264,203.518l70.976,155.837c1.24,2.723,3.859,4.561,6.842,4.801l208.069,16.732c6.271,0.505,10.773-5.916,8.163-11.64
		L544.05,250.284c-1.122-2.46-3.38-4.213-6.041-4.692L304.264,203.518z M245.942,80.473l51.515,89.207
		c3.967,6.869,13.882,6.868,17.848,0l51.504-89.207c3.967-6.87-0.991-15.457-8.923-15.457h-25.748v-54.71
		C332.138,4.614,327.525,0,321.833,0h-30.914c-5.691,0-10.305,4.614-10.305,10.305v54.71h-25.749
		C246.933,65.015,241.975,73.603,245.942,80.473z"/>
										</svg>
									</div>
									<div className="flex flex-col justify-center items-center">
										<div className="p-2 flex flex-col justify-center items-center space-y-1 py-2">
											<div className="uppercase font-bold">Track Your Order</div>
											<div className="  text-[10px]">Enter tracking number and get traking result</div>
										</div>
										<div className={`flex flex-row bg-opacity-10  teritary-${color}  rounded-3xl item-center justify-center my-3`}>
											<input
												type="type"
												name={"from"}
												placeholder=" Enter the Tracking Number"
												className="w-64 bg-transparent p-1  text-xs px-5"
												onChange={(e) => console.log('')}
												value={""}
											/>
											<div className={`w-64 secondary-${color}  px-5 rounded-3xl flex flex-row  item-center justify-center`}>
												<a className=" hover:text-[#FFB934FF] uppercase text-xs my-3 font-bold" href="#">Track Order</a>
											</div>
										</div>
									</div>
									<div className="">
										<svg fill={primary} className="my-3" version="1.1" id="Capa_1" width="100" height="100" viewBox="0 0 612 612">
											<path d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078
			C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541
			c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z
			 M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812
			c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812
			h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16
			c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z
			 M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539
			c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751
			c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907
			c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29
			l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697
			c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347
			C565.257,281.569,563.532,285.839,560.084,285.839z"/>
										</svg>
									</div>
								</div>
							</div>
							<div className={`w-full flex items-center  justify-center flex-col h-max  border-y border-black border-opacity-20 mx-20`}>
								<div className="flex flex-col justify-center items-center w-full ">
									<div className="p-2 flex flex-col justify-center items-center space-y-1 py-2  w-full">
										<div className=" uppercase font-bold">{highLightContentHeading ? highLightContentHeading[0]?.title : null}</div>
									</div>
									<div className="flex flex-row item-center justify-around w-full  mt-10 mb-20 mx-10 ">
										<div className={`flex justify-center flex-col items-center secondary-${color} rounded  w-48 h-48 space-y-5`}>
											<svg id="layer" fill={primary} height="100" width="100" version="1.1" viewBox="0 0 298.994 298.994">
												<circle cx="49.774" cy="46.77" r="20.242" />
												<path d="M75.908,73.465c-6.511,0-45.899,0-52.434,0c-12.681,0-23.05,10.317-23.113,22.998L0,168.216
				c-0.027,5.394,4.324,9.789,9.718,9.816c0.017,0,0.033,0,0.05,0c5.371,0,9.739-4.341,9.766-9.718l0.361-71.755
				c0.005-1.04,0.851-1.879,1.891-1.877c1.04,0.003,1.881,0.846,1.881,1.886l0.005,164.177c0,6.473,5.247,11.72,11.72,11.72
				s11.72-5.247,11.72-11.72v-93.682h5.06v93.682c0,6.473,5.247,11.72,11.72,11.72s11.72-5.247,11.72-11.72
				c0-85.478-0.207-81.226-0.213-164.275c0-1.129,0.915-2.045,2.044-2.045c1.129,0,2.044,0.915,2.045,2.044
				c0,0.029-0.001,0.058-0.001,0.088l0.361,71.754c0.027,5.377,4.394,9.718,9.766,9.718c0.016,0,0.034,0,0.05,0
				c5.394-0.027,9.745-4.422,9.718-9.816l-0.361-71.754C98.958,83.781,88.59,73.465,75.908,73.465z"/>
												<path d="M189.203,253.101c-0.957,6.189,3.284,11.983,9.474,12.94c6.204,0.957,11.985-3.296,12.94-9.474l6.243-40.366h-22.95
				L189.203,253.101z"/>
												<path d="M160.3,216.201h-22.95l6.243,40.366c0.866,5.602,5.695,9.609,11.193,9.609c7.003,0,12.278-6.238,11.221-13.075
				L160.3,216.201z"/>
												<path d="M177.646,100.806c10.824,0,19.586-8.77,19.586-19.586c0-10.816-8.768-19.586-19.586-19.586
				c-10.817,0-19.586,8.768-19.586,19.586C158.061,92.062,166.851,100.806,177.646,100.806z"/>
												<path d="M294.856,185.995h-4.984c2.753,0,4.984-2.231,4.984-4.984c0-16.186,0-22.665,0-30.01c0-2.753-2.231-4.984-4.984-4.984
				H283.4v-9.758c0-1.851-1.501-3.352-3.352-3.352h-22.459c-1.851,0-3.352,1.501-3.352,3.352v9.758h-6.471
				c-2.534,0-4.622,1.893-4.938,4.341c-0.072,0.556-0.046-1.395-0.046,30.653c0,2.753,2.231,4.984,4.984,4.984h-45.195v-11.876
				l27.674-12.19c4.661-2.053,6.857-7.431,4.964-12.16c-2.385-5.97-8.35-19.569-13.703-30.575
				c-3.587-7.378-11.208-12.145-19.414-12.145c-22.081,0-27.606,0-51.844,0c-2.137,0-4.209,0.723-5.881,2.053l-28.165,22.394
				c-1.716,1.365-2.905,3.284-3.361,5.428l-7.806,36.638c-1.245,5.844,3.203,11.421,9.252,11.421c4.453,0,8.307-3.137,9.233-7.483
				l7.099-33.321l21.896-17.41v59.225h-45.252c-2.285,0-4.138,1.853-4.138,4.138v14.96c0,2.285,1.853,4.138,4.138,4.138h4.583v6.971
				v52.127c0,2.285,1.852,4.138,4.138,4.138h14.959c2.285,0,4.138-1.853,4.138-4.138v-52.127v-6.971h130.972v6.971v52.127
				c0,2.285,1.853,4.138,4.138,4.138h14.959c2.285,0,4.138-1.853,4.138-4.138v-52.127v-6.971h5.565c2.285,0,4.137-1.851,4.138-4.136
				c0-0.001,0-0.001,0-0.003v-14.96c0.001,0.001,0.001-0.001,0.001-0.001C298.992,187.846,297.14,185.995,294.856,185.995z
				 M202.571,127.907c0-0.475,0.328-0.888,0.792-0.995c0.464-0.107,0.939,0.12,1.147,0.548c3.23,6.641,6.822,14.545,9.598,20.924
				l-11.537,5.082V127.907z M276.696,146.016h-15.755v-6.406h15.755V146.016z"/>
											</svg>
											<div className="text-sm font-bold ">{highLightContentData ? highLightContentData[0]?.title : null} {highLightContentData ? highLightContentData[0]?.subTitle : null}</div>
										</div>
										<div className={`flex justify-center flex-col items-center secondary-${color} rounded  w-48 h-48 space-y-5`}>
											<svg width="100" height="100"
												viewBox="0 0 24 24" id="layer" fill="none" >
												<path d="M22 12C22 13.3132 21.7413 14.6136 21.2388 15.8268C20.7362 17.0401 19.9997 18.1425 19.0711 19.0711C18.1425 19.9997 17.0401 20.7362 15.8268 21.2388C14.6136 21.7413 13.3132 22 12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C4.00035 18.1425 3.26375 17.0401 2.7612 15.8268C2.25866 14.6136 2 13.3132 2 12C2 10.6868 2.25866 9.38642 2.76121 8.17316C3.26375 6.95991 4.00035 5.85752 4.92893 4.92893C5.85752 4.00035 6.95991 3.26375 8.17317 2.7612C9.38642 2.25866 10.6868 2 12 2C13.3132 2 14.6136 2.25866 15.8268 2.76121C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12L22 12Z" stroke={primary} stroke-width="1.5" />
												<path d="M16 12C16 13.3132 15.8965 14.6136 15.6955 15.8268C15.4945 17.0401 15.1999 18.1425 14.8284 19.0711C14.457 19.9997 14.016 20.7362 13.5307 21.2388C13.0454 21.7413 12.5253 22 12 22C11.4747 22 10.9546 21.7413 10.4693 21.2388C9.98396 20.7362 9.54301 19.9997 9.17157 19.0711C8.80014 18.1425 8.5055 17.0401 8.30448 15.8268C8.10346 14.6136 8 13.3132 8 12C8 10.6868 8.10346 9.38642 8.30448 8.17316C8.5055 6.95991 8.80014 5.85752 9.17157 4.92893C9.54301 4.00035 9.98396 3.26375 10.4693 2.7612C10.9546 2.25866 11.4747 2 12 2C12.5253 2 13.0454 2.25866 13.5307 2.76121C14.016 3.26375 14.457 4.00035 14.8284 4.92893C15.1999 5.85752 15.4945 6.95991 15.6955 8.17317C15.8965 9.38642 16 10.6868 16 12L16 12Z" stroke={primary} stroke-width="1.5" />
												<path d="M2 12H22" stroke={primary} stroke-width="1.5" stroke-linecap="round" />
											</svg>
											<div className="text-sm font-bold ">{highLightContentData ? highLightContentData[1]?.title : null} {highLightContentData ? highLightContentData[1]?.subTitle : null}</div>
										</div>
										<div className={`flex justify-center flex-col items-center secondary-${color} rounded w-48 h-48 space-y-5`}>
											<svg width="100" height="100" fill="none" viewBox="0 0 24 24" id="layer" >
												<path d="M7.2998 5H22L20 12H8.37675M21 16H9L7 3H4M4 8H2M5 11H2M6 14H2M10 20C10 20.5523 9.55228 21 9 21C8.44772 21 8 20.5523 8 20C8 19.4477 8.44772 19 9 19C9.55228 19 10 19.4477 10 20ZM21 20C21 20.5523 20.5523 21 20 21C19.4477 21 19 20.5523 19 20C19 19.4477 19.4477 19 20 19C20.5523 19 21 19.4477 21 20Z" stroke={primary} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
											</svg>
											<div className="text-sm font-bold ">{highLightContentData ? highLightContentData[2]?.title : null} {highLightContentData ? highLightContentData[2]?.subTitle : null}</div>
										</div>
										<div className={`flex justify-center flex-col items-center secondary-${color} rounded  w-48 h-48 space-y-5`}>
											<svg fill={primary} version="1.1" id="Capa_1" width="100" height="100" viewBox="0 0 612 612">
												<path d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078
			C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541
			c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z
			 M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812
			c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812
			h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16
			c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z
			 M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539
			c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751
			c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907
			c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29
			l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697
			c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347
			C565.257,281.569,563.532,285.839,560.084,285.839z"/>
											</svg>
											<div className="text-sm font-bold ">{highLightContentData ? highLightContentData[3]?.title : null} {highLightContentData ? highLightContentData[3]?.subTitle : null}</div>
										</div>
									</div>
								</div>
							</div>
							<div className="w-full flex items-center justify-center flex-col h-[500px]  border-y border-black border-opacity-20 mx-10">
								<div className={`flex flex-col justify-center items-center w-full  secondary-${color}`}>
									<div className="p-2 flex flex-col justify-center items-center space-y-1 py-2  w-full">
										<div className=" uppercase font-bold my-3">{promiseContentHeading ? promiseContentHeading[0]?.title : null}</div>
									</div>
									<div className="flex flex-row justify-around item-center w-full my-10 mx-10">
										<div className={`w-[250px] flex flex-col h-max items-center justify-center py-3  primary-${color} shadow-xl rounded-xl`}>
											<div>
												<svg fill={secondary} height="100" width="100" version="1.1" id="Capa_1" viewBox="0 0 490 490">
													<path d="M232.582,75.479c-93.474,0-169.521,76.049-169.521,169.521c0,93.474,76.047,169.519,169.521,169.519
		c93.473,0,169.519-76.046,169.519-169.519C402.101,151.527,326.055,75.479,232.582,75.479z M364.829,302.657
		c-12.73,5.033-26.869,9.256-42.051,12.604c2.236-18.367,3.585-37.736,3.988-57.643h49.541
		C374.925,273.502,370.957,288.655,364.829,302.657z M88.856,257.618h49.539c0.402,19.902,1.751,39.266,3.986,57.628
		c-15.183-3.348-29.322-7.565-42.047-12.588C94.206,288.656,90.239,273.502,88.856,257.618z M100.336,187.338
		c12.735-5.034,26.876-9.257,42.064-12.605c-2.242,18.391-3.6,37.768-4.004,57.648h-49.54
		C90.239,216.496,94.206,201.342,100.336,187.338z M245.2,165.671c17.799,0.471,35.1,1.936,51.528,4.33
		c2.714,19.603,4.341,40.617,4.797,62.38H245.2V165.671z M245.2,140.428v-39.154c13.385,1.165,26.252,4.165,38.35,8.748
		c3.367,10.412,6.296,21.787,8.762,33.925C277.116,142.021,261.329,140.836,245.2,140.428z M219.964,140.428
		c-16.125,0.407-31.905,1.592-47.097,3.516c2.464-12.141,5.39-23.516,8.751-33.924c12.097-4.582,24.963-7.581,38.346-8.746V140.428z
		 M219.964,165.671l0.001,66.71h-56.327c0.457-21.728,2.092-42.752,4.813-62.384C184.876,167.605,202.169,166.141,219.964,165.671z
		 M163.637,257.618h56.328l0.001,66.711c-17.771-0.473-35.082-1.938-51.535-4.341C165.718,300.389,164.092,279.378,163.637,257.618z
		 M219.966,349.57v39.155c-13.387-1.165-26.254-4.165-38.352-8.749c-3.369-10.415-6.3-21.795-8.767-33.938
		C188.061,347.971,203.854,349.162,219.966,349.57z M245.202,349.571c16.129-0.407,31.914-1.593,47.11-3.519
		c-2.466,12.137-5.396,23.512-8.761,33.924c-12.098,4.584-24.965,7.583-38.35,8.749V349.571z M245.202,324.329l-0.002-66.711h56.325
		c-0.456,21.763-2.081,42.778-4.797,62.382C280.3,322.395,263.001,323.858,245.202,324.329z M326.767,232.381
		c-0.403-19.907-1.752-39.276-3.988-57.644c15.182,3.349,29.319,7.571,42.051,12.604c6.128,14.003,10.096,29.156,11.478,45.039
		H326.767z M344.57,154.136c-8.272-2.254-16.886-4.245-25.778-5.966c-1.368-7.613-2.9-14.988-4.595-22.084
		C325.612,133.945,335.847,143.404,344.57,154.136z M150.977,126.078c-1.692,7.097-3.227,14.472-4.594,22.086
		c-8.896,1.722-17.511,3.714-25.788,5.968C129.323,143.398,139.558,133.939,150.977,126.078z M120.589,335.857
		c8.273,2.251,16.887,4.244,25.778,5.965c1.368,7.615,2.901,14.992,4.596,22.088C139.546,356.05,129.313,346.592,120.589,335.857z
		 M314.199,363.912c1.692-7.094,3.226-14.469,4.593-22.081c8.895-1.722,17.506-3.714,25.778-5.968
		C335.847,346.596,325.614,356.053,314.199,363.912z"/>
													<path d="M489.36,233.99c-1.15-2.516-3.66-4.129-6.428-4.129h-17.951c-3.603-56.469-27.298-109.063-67.67-149.434
		C353.353,36.468,294.906,12.26,232.74,12.26S112.128,36.468,68.169,80.428C24.209,124.387,0,182.833,0,245
		c0,62.166,24.209,120.611,68.169,164.571c43.959,43.96,102.404,68.169,164.571,68.169c52.738,0,104.401-18.133,145.472-51.055
		c5.439-4.359,6.313-12.301,1.953-17.738c-4.357-5.436-12.297-6.312-17.737-1.953c-37.14,29.773-81.986,45.51-129.688,45.51
		c-114.417,0-207.504-93.087-207.504-207.504c0-114.418,93.087-207.504,207.504-207.504c109.327,0,199.169,84.988,206.948,192.365
		h-16.896c-2.764,0-5.277,1.613-6.427,4.129c-1.149,2.515-0.726,5.47,1.084,7.562l30.068,34.746
		c1.342,1.552,3.292,2.442,5.343,2.442c2.053,0,4.001-0.891,5.344-2.441l30.072-34.746
		C490.086,239.461,490.511,236.505,489.36,233.99z"/>
												</svg>
											</div>
											<div className="w-[200px] font-semibold text-sm text-center  px-3 py-3 ">{promiseContentData ? promiseContentData[0]?.title : null} </div>
											<div className="w-[250px] text-xs  text-center p-3 px-10 rounded min-h-20">{promiseContentData ? promiseContentData[0]?.subTitle : null}</div>
										</div>
										<div className={`w-[250px] flex flex-col items-center justify-center py-3 primary-${color}  shadow-xl rounded-xl`}>
											<div className="">
												<svg fill={secondary} width="100" height="100" viewBox="0 0 50 50">
													<path d="M4 1C3.447 1 3 1.448 3 2L3 10C3 10.553 3.447 11 4 11L15 11C15.553 11 16 10.553 16 10L16 2C16 1.448 15.553 1 15 1L4 1 z M 37.164062 9.5C35.289759 9.5 33.707216 10.100433 32.857422 11L27 11 A 1.0001 1.0001 0 1 0 27 13L32.259766 13C32.645045 14.435874 34.65739 15.5 37.164062 15.5C38.270063 15.5 38.997172 15.287031 39.451172 14.832031C40.016172 14.264031 40.014719 13.463453 40.011719 12.689453L40.009766 12.498047L40.011719 12.308594C40.014719 11.535594 40.017172 10.735969 39.451172 10.167969C38.997172 9.7119687 38.272922 9.5 37.169922 9.5L37.164062 9.5 z M 2 13C1.447 13 1 13.448 1 14L1 22C1 22.552 1.447 23 2 23L11.015625 23C11.141625 21.347 12.102 19.217484 14 19.021484L14 14C14 13.448 13.553 13 13 13L2 13 z M 33.248047 16.685547C34.111047 23.246547 32.823125 29.604359 29.828125 33.193359C28.272125 35.056359 26.401578 36 24.267578 36C23.280578 36 22.695906 35.350687 22.378906 34.804688C21.522906 33.329687 21.375734 30.4365 23.302734 26.5625C22.012734 26.8515 20.394547 27 18.435547 27C17.257114 27 14.548266 26.991755 12.748047 26.035156C12.564418 25.937694 12.392472 25.829279 12.230469 25.710938C11.915435 25.480918 11.640065 25.214349 11.435547 24.894531C11.363467 24.927922 11.299313 24.965842 11.228516 25L1 25C0.447 25 0 25.448 0 26C0 26.553 0.447 27 1 27L8.140625 27C5.1303891 29.545041 4.0970005 32.516944 4.0371094 32.726562C3.9621094 32.992562 3.9995781 33.278625 4.1425781 33.515625C4.2855781 33.752625 4.5190625 33.920516 4.7890625 33.978516L19.869141 38L31.058594 38C31.023594 37.69 31 37.362 31 37C31 31.673 36.14 27 42 27C42.181 27 42.352391 27.009578 42.525391 27.017578C42.167391 23.010578 40.234813 19.650906 38.507812 17.378906C38.093812 17.451906 37.653062 17.5 37.164062 17.5C35.690063 17.5 34.351047 17.202547 33.248047 16.685547 z M 14.28125 21C14.184077 21 14.090938 21.029755 14 21.076172C13.998509 21.076936 13.997583 21.079303 13.996094 21.080078C13.882067 21.139256 13.775918 21.234863 13.675781 21.351562C13.662059 21.367468 13.648179 21.381642 13.634766 21.398438C13.535952 21.522709 13.444734 21.665208 13.365234 21.828125C13.265172 22.032233 13.18821 22.260101 13.126953 22.494141C13.107622 22.56791 13.098893 22.636507 13.083984 22.710938C13.064878 22.805995 13.03673 22.899883 13.025391 22.994141C13.033791 22.993923 13.04048 22.988703 13.048828 22.988281C13.033436 23.115491 13 23.246564 13 23.367188C13 24.385188 14.858547 25 18.435547 25C22.014547 25 25 24.386188 25 23.367188C25 22.350188 24.426797 21 23.716797 21L14.28125 21 z M 42 29C37.475 29 33 32.574 33 37C33 39.74 34.19 40 35 40C36.659 40 36 36.598 40 35C41.175 34.531 42.330391 34.384766 43.400391 34.384766C45.209391 34.384766 46.774109 34.804688 47.787109 34.804688C48.552109 34.804688 49.001953 34.564703 49.001953 33.720703C49.000953 32.999703 47.704 29 42 29 z M 43.179688 36.392578C42.282688 36.414578 41.479187 36.563422 40.742188 36.857422C40.554187 36.932422 40.385562 37.012703 40.226562 37.095703C40.087562 37.369703 40 37.673 40 38C40 39.103 40.897 40 42 40C43.103 40 44 39.103 44 38C44 37.339 43.674687 36.756578 43.179688 36.392578 z M 6.1933594 36.421875C6.0743594 36.937875 6 37.465 6 38C6 41.859 9.141 45 13 45C16.172 45 18.853938 42.876516 19.710938 39.978516C19.590938 39.969516 19.470516 39.964594 19.353516 39.933594L16.78125 39.246094C16.25425 40.839094 14.768 42 13 42C10.794 42 9 40.206 9 38C9 37.723 9.0348437 37.454359 9.0898438 37.193359L6.1933594 36.421875 z M 45.732422 36.59375C45.898422 37.03375 46 37.504 46 38C46 40.206 44.206 42 42 42C40.262 42 38.795141 40.880125 38.244141 39.328125C38.220141 39.376125 38.196828 39.424656 38.173828 39.472656C37.816828 40.207656 37.264 41.317297 36.125 41.779297C37.384 43.731297 39.565 45 42 45C45.859 45 49 41.859 49 38C49 37.545 48.940516 37.096297 48.853516 36.654297C48.534516 36.742297 48.190156 36.804688 47.785156 36.804688C47.208156 36.804688 46.583875 36.715141 45.921875 36.619141C45.861875 36.610141 45.793422 36.60275 45.732422 36.59375 z M 11.029297 37.712891C11.015297 37.807891 11 37.902 11 38C11 39.103 11.897 40 13 40C13.843 40 14.562469 39.472422 14.855469 38.732422L11.029297 37.712891 z" />
												</svg>
											</div>
											<div className="w-[200px] font-semibold text-sm text-center ] px-3 py-3 ">{promiseContentData ? promiseContentData[1]?.title : null} </div>
											<div className="w-[250px] text-xs   text-center p-3 px-10  rounded min-h-20">{promiseContentData ? promiseContentData[1]?.subTitle : null}</div>
										</div>

										<div className={`w-[250px] flex flex-col items-center justify-center primary-${color}  shadow-xl rounded-xl`}>
											<div>
												<svg width="100" height="100" viewBox="0 0 1024 1024" fill={secondary} className="icon" version="1.1"><path d="M107.19232 617.00096h562.14528v77.76256H260.36224c-12.19584-33.49504-44.34944-57.4976-82.0224-57.4976-37.10976 0-68.864 23.296-81.46944 56.02304a37.2224 37.2224 0 0 1-26.90048-35.74784v-3.30752a37.2224 37.2224 0 0 1 37.2224-37.23264z m133.20192 98.85696a65.024 65.024 0 0 1-64.95232 64.94208c-35.79904 0-64.94208-29.1328-64.94208-64.94208s29.14304-64.95232 64.94208-64.95232a65.024 65.024 0 0 1 64.95232 64.95232z m-19.8656 0a45.13792 45.13792 0 0 0-45.08672-45.08672c-24.86272 0-45.07648 20.23424-45.07648 45.08672s20.224 45.07648 45.07648 45.07648a45.11744 45.11744 0 0 0 45.08672-45.07648z m676.32128 0c0 35.80928-29.14304 64.94208-64.95232 64.94208s-64.94208-29.1328-64.94208-64.94208 29.1328-64.95232 64.94208-64.95232 64.95232 29.14304 64.95232 64.95232z m-19.85536 0c0-24.86272-20.23424-45.08672-45.08672-45.08672s-45.07648 20.23424-45.07648 45.08672 20.224 45.07648 45.07648 45.07648 45.08672-20.21376 45.08672-45.07648zM991.56992 529.3056v146.8416c0 6.85056-5.56032 12.41088-12.41088 12.41088h-64.88064c-13.74208-30.21824-44.17536-51.3024-79.48288-51.3024s-65.75104 21.08416-79.49312 51.3024h-43.776a12.41088 12.41088 0 0 1-12.41088-12.41088V381.22496c0-6.8608 5.56032-12.41088 12.41088-12.41088h163.38944c6.85056 0 17.27488 2.28352 24.82176 12.41088l91.83232 148.08064z m-57.9072-32.26624l-55.83872-92.66176c-4.31104-7.97696-9.61536-12.40064-28.54912-12.40064H747.9296c-6.85056 0-12.41088 5.55008-12.41088 12.40064v92.66176c0 6.8608 5.56032 12.41088 12.41088 12.41088h173.32224c6.85056 0 12.41088-5.55008 12.41088-12.41088z m48.384 141.04576a11.58144 11.58144 0 0 0-23.16288 0v21.93408a11.58144 11.58144 0 0 0 23.16288 0v-21.93408zM32.43008 594.78016h636.90752V243.2H32.43008v351.58016z" /></svg>
											</div>
											<div className="w-[200px] font-semibold text-sm text-center  px-3 py-3 ">{promiseContentData ? promiseContentData[2]?.title : null} </div>
											<div className="w-[250px] text-xs text-center p-3 rounded min-h-20 px-10">{promiseContentData ? promiseContentData[2]?.subTitle : null}</div>
										</div>
										<div className={`w-[250px] flex flex-col items-center  primary-${color} justify-center shadow-xl rounded-xl`}>
											<div className="">
												<svg fill={secondary} height="100" width="100" version="1.1" id="Capa_1" viewBox="0 0 490 490">
													<circle cx="158.808" cy="191.789" r="14.446" />
													<path d="M449.228,91.881c-18.694,0-34.436,12.584-39.249,29.74h-18.343c-6.092,0-11.03,4.938-11.03,11.029
		c0,6.094,4.938,11.031,11.03,11.031h18.343c4.813,17.156,20.555,29.74,39.249,29.74c22.517,0,40.772-18.252,40.772-40.771
		C490,110.135,471.745,91.881,449.228,91.881z"/>
													<path d="M449.824,186.672c-10.619,0-20.052,5.064-26.027,12.904c-3.183,3.711-14.34,15.705-28.986,20.158
		c-15.983,4.859-32.241-3.533-32.323-3.576c-6.941-3.764-15.609-1.188-19.372,5.748c-3.76,6.938-0.862,15.066,5.75,19.371
		c13.889,9.039,41.815,9.578,54.258,5.797c5.011-1.523,9.69-3.568,13.992-5.881v69.73c0,10.506,4.957,19.846,12.653,25.83v127.914
		c0,11.076,8.979,20.055,20.056,20.055c11.077,0,20.057-8.979,20.057-20.055V336.754c7.696-5.984,12.652-15.326,12.652-25.83
		v-91.543C482.533,201.316,467.89,186.672,449.824,186.672z"/>
													<path d="M354.974,204.584c11.248,0,15.301,6.238,26.073,6.238c6.088,0,13.171-2.184,13.171-5.445v-23.178
		c0-8.082-6.576-14.658-14.658-14.658h-42.08v19.133c0,1.385-1.122,2.506-2.507,2.506H322.96c-1.385,0-2.508-1.121-2.508-2.506
		v-19.133h-42.079c-8.082,0-14.658,6.576-14.658,14.658v101.188c0,8.082,6.576,14.658,14.658,14.658H379.56
		c8.082,0,14.658-6.576,14.658-14.658v-20.158c0-0.727-0.315-1.416-0.862-1.893c-0.547-0.475-1.271-0.648-1.992-0.59
		c-47.621,3.824-69.433-21.543-58.5-43.002C337.056,209.516,345.739,204.584,354.974,204.584z"/>
													<path d="M256.081,348.221h-20.308V20.318c0-8.307-6.735-15.041-15.043-15.041H45.377c-8.307,0-15.041,6.734-15.041,15.041v327.902
		H10.027C4.489,348.221,0,352.709,0,358.248v35.514c0,5.539,4.489,10.027,10.027,10.027h246.054c5.538,0,10.028-4.488,10.028-10.027
		v-35.514C266.109,352.709,261.619,348.221,256.081,348.221z M60.42,35.361h145.269v312.855H60.42V35.361z"/>
												</svg>
											</div>
											<div className="w-[200px] font-semibold text-sm text-center px-3 py-3 ">{promiseContentData ? promiseContentData[3]?.title : null} </div>
											<div className="w-[250px] text-xs  text-center p-3 px-10  rounded min-h-20">{promiseContentData ? promiseContentData[3]?.subTitle : null}</div>
										</div>
									</div>
								</div>
							</div>
							<div className="w-full flex items-center justify-center flex-col h-96 border-y border-black border-opacity-20">
								<div className="flex flex-col justify-center items-center w-full">
									<div className="p-2 flex flex-col justify-center items-center space-y-1 py-2  w-full">
										<div className=" uppercase font-bold my-5">{workContentHeading ? workContentHeading[0]?.title : null}</div>
									</div>
								</div>
								<div className="flex flex-row justify-around w-full">
									<div className={`flex justify-center  secondary-${color} flex-col items-center rounded shadow-xl w-64 h-56`}>
										<svg width="100" height="100" viewBox="0 0 512 512">
											<path fill={primary} d="M268.383 22.168l-55.918 84.482 29.717 3.733c-9.22 30.13-11.095 50.878-8.885 92.12 14.138-2.23 25.56-3.025 40.586 1.39-9.877-36.84-8.844-49.427-4.88-89.768l32.622 2.277-33.242-94.234zm218.482 2.21l-108.36 30.03 20.915 25.975c-49.512 31.019-80.331 55.548-104.74 123.164 13.201-.152 28.098 2.921 44.174 9.004 5.728-44.666 33.74-76.14 79.302-108.918l19.983 24.816 48.726-104.07zm-463.574 2.31L89.17 129.173l19.084-28.711c35.554 32.44 58.145 76.33 57.308 107.43 18.568-8.696 29.927-9.527 49.735-3.778-8.105-31.203-43.577-108.722-91.639-129.103l16.57-26.037L23.292 26.687zm276.117 214.667c-5.28.12-10.21 2.415-16.937 9.594l-6.565 6.969-6.812-6.72c-7.387-7.28-13.216-9.29-19.125-9.03-5.908.26-12.855 3.367-20.625 9.656l-6.217 5.03-5.906-5.374c-8.9-8.052-16.485-10.439-23.75-10.064-5.288.274-10.775 2.266-16.25 5.75l40.966 73.69c15.454 9.451 47.034 13.006 68.75 2.062l39.594-73.344c-7.51-3.062-14.26-6.202-20.094-7.406-2.112-.437-4.07-.756-5.968-.813-.354-.01-.71-.008-1.06 0zm-89.97 96.188v.002c-18.035 12.742-32.516 34.717-38.125 66.904-5.435 31.196 3.129 52.266 18.283 66.625 15.155 14.36 37.902 21.736 61 21.436 23.1-.3 46.136-8.31 61.625-22.936 15.49-14.627 24.249-35.425 19.281-65.187-5.137-30.757-18.4-52.148-35.19-65.094-28.482 15.056-64.095 11.856-86.875-1.75z" />
										</svg>
										<div className="text-sm font-bold  py-2">{workContentData ? workContentData[0]?.title : null}</div>
										<div className="text-xs  px-8 py-2 text-center">{workContentData ? workContentData[0]?.subTille : null}</div>
									</div>
									<div className={`flex justify-center secondary-${color} flex-col items-center  rounded shadow-xl  w-64 h-56`}>
										<svg width="100" height="100" viewBox="0 0 20 20">
											<path fill={primary} d="M2.84210526,3.86504044 L2.84210526,11.2988054 C2.84210526,15.3455734 6.0468039,18.6261272 10,18.6261272 C13.9531961,18.6261272 17.1578947,15.3455734 17.1578947,11.2988054 L17.1578947,3.86837364 L9.9567671,1.44685758 L2.84210526,3.86504044 Z M9.95451486,0 L18.5,2.87358183 L18.5,11.2988054 C18.5,16.1043425 14.6944204,20 10,20 C5.30557963,20 1.5,16.1043425 1.5,11.2988054 L1.5,2.87358183 L9.95451486,0 Z M14.3737014,6.48544473 C14.0967483,6.23334258 13.6725898,6.25880251 13.4263169,6.54231108 L13.4263169,6.54231108 L9.11047784,11.5106915 L6.32211371,8.42587388 C6.07040936,8.1474088 5.64584183,8.13054472 5.37381559,8.38820691 C5.10178936,8.6458691 5.08531523,9.08048613 5.33701959,9.35895121 L5.33701959,9.35895121 L8.62781212,12.9996145 C8.89702337,13.2974478 9.35842515,13.2927747 9.62182714,12.9895471 L9.62182714,12.9895471 L14.4292528,7.45525373 C14.6755257,7.17174516 14.6506545,6.73754688 14.3737014,6.48544473 Z" />
										</svg>
										<div className="text-sm font-bold  py-2">{workContentData ? workContentData[1]?.title : null}</div>
										<div className="text-xs  px-8 py-2 text-center">{workContentData ? workContentData[1]?.subTille : null}</div>
									</div>
									<div className={`flex justify-center secondary-${color} flex-col items-center   rounded shadow-xl  w-64 h-56`}>
										<svg fill={primary} width="100" height="100" version="1.1" id="Layer_1" viewBox="0 0 496 496">
											<path d="M144,144H32v112h112V144z M128,240H48v-80h80V240z" />
											<path d="M272,144H160v112h112V144z M256,240h-80v-80h80V240z" />
											<path d="M144,272H32v112h112V272z M128,368H48v-80h80V368z" />
											<path d="M272,272H160v112h112V272z M256,368h-80v-80h80V368z" />
											<polygon points="80,224 96,224 96,208 112,208 112,192 96,192 96,176 80,176 80,192 64,192 64,208 80,208 			" />
											<rect x="192" y="192" width="48" height="16" />
											<polygon points="69.656,357.656 88,339.312 106.344,357.656 117.656,346.344 99.312,328 117.656,309.656 106.344,298.344 
				88,316.688 69.656,298.344 58.344,309.656 76.688,328 58.344,346.344 			"/>
											<rect x="192" y="304" width="48" height="16" />
											<rect x="192" y="336" width="48" height="16" />
											<rect x="256" y="80" width="16" height="16" />
											<rect x="32" y="80" width="208" height="16" />
											<path d="M464,432H53.784L0.456,464l53.328,32H464c17.648,0,32-14.352,32-32S481.648,432,464,432z M384,480H58.216l-26.672-16
				l26.672-16H384V480z M416,480h-16v-32h16V480z M464,480h-32v-32h32c8.816,0,16,7.176,16,16C480,472.824,472.816,480,464,480z"/>
											<path d="M304,48V0H0v416h304v-48h192V48H304z M288,400H16V128h272V400z M288,112H16V16h272V112z M480,352H304V64h176V352z" />
											<path d="M387.704,334.752l4.296,2.736l4.296-2.736C399.064,332.984,464,290.648,464,208S399.064,83.016,396.296,81.248
				L392,78.512l-4.296,2.736C384.936,83.016,320,125.352,320,208S384.936,332.984,387.704,334.752z M392.016,97.848
				c8.776,6.728,29,24.344,42.584,52.24C422.656,141.28,407.952,136,392,136c-15.912,0-30.584,5.248-42.512,14.016
				C363.08,122.224,383.256,104.592,392.016,97.848z M392,152c30.872,0,56,25.128,56,56s-25.128,56-56,56s-56-25.128-56-56
				S361.128,152,392,152z M392,280c15.912,0,30.576-5.248,42.512-14.016c-13.6,27.792-33.776,45.424-42.528,52.168
				c-8.776-6.728-29-24.344-42.584-52.24C361.344,274.72,376.048,280,392,280z"/>
											<polygon points="384,248 400,248 400,216 432,216 432,200 400,200 400,168 384,168 384,200 352,200 352,216 384,216 			" />
										</svg>
										<div className="text-sm font-bold  py-2">{workContentData ? workContentData[2]?.title : null}</div>
										<div className="text-xs  px-8 py-2 text-center">{workContentData ? workContentData[2]?.subTille : null}</div>
									</div>
								</div> 
							</div>
							<div className={`w-full flex flex-row items-center h-64 px-10 secondary-${color}  border-y border-black border-opacity-20`}>
								<div className="flex flex-col w-1/2 text-md m-4 p-4">
									<div className="text-2xl font-bold py-3 uppercase ">{partnerConentData ? partnerConentData[0]?.title : null}</div>
									<div className="text-md  text-justify">{partnerConentData ? partnerConentData[0]?.description : null}
									</div>
								</div>
								<div className="flex w-1/2">
									{partnerConentData && partnerConentData[0]?.src ? <img src={partnerConentData[0]?.src} width="600" height="300" />
										: <img src={'https://via.placeholder.com/1000x337'} width="600" height="300" />}

								</div>
							</div>

						</div >}
				</div>}
		</>
	)
}

export default LogisticHome
